<template>
  <div>
    <div class="panel">
      <div
        class="panel-content-container"
        style="box-shadow: none !important; padding: 25px"
        v-if="
          $store.state.user.role.permissions.includes('can_do_resident') &&
          $store.state.user.role.permissions.includes('can_view_resident')
        "
      >
        <div v-if="!loadingPatient" style="overflow-y: auto">
          <div>
            <div class="patient-edit-container">
              <div
                class="horizontal-tabs-container"
                style="margin-bottom: 20px"
              >
                <div class="horizontal-tabs">
                  <div
                    v-for="(item, index) in navigationItems"
                    :key="index"
                    class="horizontal-tab-item"
                    :class="{
                      'active-tab': selectedNavigation == item.link,
                      'completed-tab': item.completed,
                    }"
                    @click="selectedNavigation = item.link"
                  >
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </div>
              <div class="patient-form-content" style="overflow-y: hidden">
                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'personal_information'"
                >
                  <div
                    class="resident-header-controls"
                    style="
                      display: flex;
                      gap: 20px;
                      align-items: flex-start;
                      margin-bottom: 20px;
                      flex-wrap: wrap;
                    "
                  >
                    <div
                      class="patient-form-image-container"
                      style="flex: 0 0 300px"
                    >
                      <label
                        v-if="previewImage"
                        for="patient-image-upload"
                        :v-model="previewImage"
                        class="uploading-image-container"
                      >
                        <img :src="previewImage" class="uploading-image" />
                        <i class="pi pi-pencil edit-icon"></i>
                        <p class="edit-icon-text">Edit Image</p>
                      </label>
                      <div
                        v-if="
                          patient &&
                          patient.image_information &&
                          patient.image_information.created_at
                        "
                        style="
                          margin-top: 10px;
                          text-align: center;
                          color: #666;
                          font-size: 0.9em;
                          font-weight: 500;
                        "
                      >
                        <p style="margin: 0">
                          Updated: {{ patient.image_information.created_at }}
                        </p>
                      </div>

                      <div
                        v-if="!previewImage"
                        style="
                          height: 250px;
                          display: flex;
                          border-radius: 8px;
                          flex-direction: column;
                          align-items: center;
                          justify-content: space-around;
                          background-color: #f3f4f4;
                        "
                      >
                        <i
                          class="pi pi-user"
                          style="font-size: 5em !important; color: #d8dcdc"
                        ></i>
                        <p>
                          {{ $resident({ capitalize: true }) }} photo to display
                          here
                        </p>
                      </div>
                      <label
                        v-if="!previewImage"
                        for="patient-image-upload"
                        class="image-file-upload"
                        style="
                          width: 100%;
                          box-sizing: border-box;
                          text-align: center;
                          margin: 0 auto;
                          font-weight: bold;
                          padding: 5px 10px;
                          border-radius: 4px;
                          cursor: pointer;
                          color: white;
                          background-color: #0870dc;
                          margin-top: 10px;
                          display: block;
                        "
                        :v-model="previewImage"
                      >
                        Upload {{ $resident({ capitalize: true }) }} Image
                      </label>
                      <input
                        type="file"
                        id="patient-image-upload"
                        accept="image/jpeg,image/png"
                        @change="uploadImage"
                        style="display: none"
                      />
                      <button
                        v-if="previewImage"
                        class="image-file-upload green-button"
                        style="
                          width: 100%;
                          box-sizing: border-box;
                          margin: 0 auto;
                          padding: 5px 10px;
                          border-radius: 4px;
                          cursor: pointer;
                          color: white;
                          background-color: #0870dc;
                          margin-top: 10px;
                          display: block;
                        "
                        @click="submitImage()"
                      >
                        Save Image
                      </button>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 20px;
                        flex: 0 1 auto;
                        max-width: 500px;
                        min-width: 400px;
                      "
                    >
                      <div
                        class="status-control"
                        style="
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          grid-gap: 10px;
                          align-items: center;
                          padding: 15px;
                          background: #f3f4f4;
                          border-radius: 8px;
                        "
                      >
                        <p
                          style="
                            grid-column: span 2;
                            margin: 0;
                            font-weight: bold;
                          "
                        >
                          {{ $resident({ capitalize: true }) }} Status
                        </p>
                        <Dropdown
                          v-model="selectedStatus"
                          :options="statusOptions"
                          optionLabel="label"
                          optionValue="value"
                          :placeholder="'Set Status'"
                          style="width: 100%; border: 1px solid #dadada"
                        />
                        <button
                          class="button-spaced"
                          style="
                            background-color: #00ad50;
                            height: 100%;
                            padding: 5px 10px;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            color: white;
                            font-weight: bold;
                          "
                          @click="saveStatus()"
                        >
                          Save Status
                        </button>
                      </div>
                      <!-- Prescribers and pharmacists should not be allowed to change resident locations -->
                      <div
                        class="location-control"
                        style="
                          padding: 15px;
                          background: #f3f4f4;
                          border-radius: 8px;
                        "
                      >
                        <h3 style="margin: 0; margin-bottom: 10px">Location</h3>
                        <p
                          style="text-align: left; font-size: 1em"
                          v-if="
                            patient.physical_location &&
                            patient.physical_location.location
                          "
                        >
                          Current Location:
                          {{
                            patient.physical_location.location.facility
                              ? patient.physical_location.location.facility
                                  .name + " -"
                              : ""
                          }}
                          <b>{{ patient.physical_location.location.name }}</b>
                        </p>
                        <div class="form-fields">
                          <div
                            class="form-field wide-text-field"
                            v-if="facilities && facilities.length"
                          >
                            <label for="first_name">Facility</label>
                            <Dropdown
                              v-model="selectedFacility"
                              :options="facilities"
                              optionLabel="label"
                              @change="retrieveSelectedFacilityLocations()"
                              :placeholder="
                                selectedFacility
                                  ? selectedFacility.name
                                  : 'Select facility'
                              "
                              :disabled="
                                $store.state.user.type === 'prescriber' ||
                                $store.state.user.type === 'pharmacist'
                                  ? true
                                  : false
                              "
                            />
                          </div>
                          <div
                            class="form-field wide-text-field"
                            v-if="nodes && nodes.length"
                          >
                            <label for="first_name">Location</label>
                            <div v-if="loadingLocations">
                              <i
                                class="pi pi-spin pi-spinner"
                                style="
                                  font-size: 2rem !important;
                                  margin-top: 10px;
                                "
                              ></i>
                            </div>
                            <TreeSelect
                              v-model="selectedNodeKey"
                              :options="nodes"
                              ariaLabelledBy="name"
                              placeholder="Select Item"
                            />
                          </div>
                        </div>
                        <div style="display: flex">
                          <button
                            v-if="$store.state.user.type === 'nurse'"
                            class="button complete-button"
                            style="margin-top: 1em; font-weight: bold"
                            @click="confirmFacilityLocation()"
                          >
                            Update Location
                          </button>
                          <button
                            v-else
                            disabled
                            style="
                              margin-top: 1em;
                              font-weight: bold;
                              cursor: not-allowed;
                            "
                          >
                            Update Location
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="personal-info-form-content">
                    <h3 style="margin: 0; margin-bottom: 15px">
                      Personal Information
                    </h3>
                    <div
                      v-if="personalInformation.similar_sounding_name"
                      style="
                        background-color: #fef2f2;
                        border: 1px solid #fca5a5;
                        border-radius: 8px;
                        padding: 12px 16px;
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        width: fit-content;
                      "
                    >
                      <i
                        class="pi pi-exclamation-triangle"
                        style="color: #ef4444; font-size: 1.2rem"
                      ></i>
                      <span
                        style="
                          font-size: 0.95em;
                          font-weight: 600;
                          color: #b91c1c;
                        "
                        >This patient has a similar sounding name to another
                        {{ $resident() }}.</span
                      >
                    </div>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name"
                          >First Name <span style="color: red">*</span></label
                        >
                        <input
                          type="text"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="personalInformation.first_name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name"
                          >Last Name <span style="color: red">*</span></label
                        >
                        <input
                          type="text"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="personalInformation.last_name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Preferred Name</label>
                        <input
                          type="text"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="personalInformation.preferred_name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name"
                          >Sex
                          <span v-if="!isSimplified" style="color: red"
                            >*</span
                          ></label
                        >
                        <Dropdown
                          :disabled="$store.state.user.integration_id"
                          v-model="personalInformation.sex"
                          :options="sex"
                          optionLabel="sex"
                          optionValue="sex"
                          :placeholder="
                            personalInformation.sex
                              ? personalInformation.sex
                              : 'Select sex'
                          "
                          style="width: 100%"
                        />
                      </div>

                      <div class="form-field date-field">
                        <!-- - {{ personalInformation.dob }} -->
                        <label for="first_name"
                          >Date of Birth
                          <span v-if="!isSimplified" style="color: red"
                            >*</span
                          ></label
                        >
                        <input
                          type="date"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="personalInformation.dob"
                        />
                        <!-- <InputMask style="background-color: #f3f4f4" mask="99/99/9999"
                                                        v-model="editDob" placeholder="01/01/1920"/> -->
                      </div>
                    </div>
                    <div style="display: flex">
                      <button
                        class="button green-button"
                        style="margin-top: 1em; font-weight: bold"
                        @click="validateDOB()"
                      >
                        Save Personal Information
                      </button>
                    </div>
                    <div
                      style="
                        text-align: left;
                        margin-top: 1.5em;
                        border-left: 4px solid #0870dc;
                        padding-left: 10px;
                      "
                    >
                      <p
                        v-if="psychotropicConsent"
                        style="margin: 0; font-size: 0.9em; color: #555"
                      >
                        <b>Latest Psychotropic Consent:</b>
                        {{
                          psychotropicConsent.given_date
                            ? psychotropicConsent.given_date
                            : "N/A"
                        }}
                        Given By:
                        {{
                          psychotropicConsent.given_by
                            ? psychotropicConsent.given_by
                            : "Unknown"
                        }}
                      </p>
                      <p
                        v-if="prescribingConsent"
                        style="margin: 5px 0 0 0; font-size: 0.9em; color: #555"
                      >
                        <b>Latest Prescribing Consent:</b>
                        {{
                          prescribingConsent.given_date
                            ? prescribingConsent.given_date
                            : "N/A"
                        }}
                        Given By:
                        {{
                          prescribingConsent.given_by
                            ? prescribingConsent.given_by
                            : "Unknown"
                        }}
                      </p>
                    </div>
                    <p
                      style="text-align: left; font-size: 1em; color: red"
                      v-if="errorDOB"
                    >
                      DOB is incorrectly entered, DOB must be DD / MM / YYYY
                      e.g. 10/12/1950.
                    </p>
                    <div
                      class="field-checkbox"
                      style="
                        display: flex;
                        margin-top: 1.5em;
                        margin-bottom: 1em;
                      "
                    >
                      <Checkbox
                        inputId="informed_consent"
                        :binary="true"
                        v-model="consent.has_consented"
                      />
                      <label
                        style="
                          font-size: 1em;
                          padding-left: 10px;
                          font-weight: bold;
                        "
                        for="informed_consent"
                      >
                        Informed Consent Given
                      </label>
                    </div>

                    <div
                      style="
                        display: flex;
                        gap: 20px;
                        align-items: flex-end;
                        margin-bottom: 1em;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                        class="form-field text-field"
                        style="margin-top: 0; width: 250px"
                      >
                        <label for="consent_type"
                          >Consent Type
                          <span v-if="!isSimplified" style="color: red"
                            >*</span
                          ></label
                        >
                        <Dropdown
                          v-model="consent.consent_type"
                          :options="consentTypeOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select Consent Type"
                          style="width: 100%"
                        />
                      </div>
                      <div
                        class="form-field text-field"
                        style="margin-top: 0; width: 250px"
                      >
                        <label for="consent_by"
                          >Informed Consent Given By</label
                        >
                        <input
                          type="text"
                          name="consent_by"
                          :disabled="$store.state.user.integration_id"
                          v-model="consent.given_by"
                        />
                      </div>
                      <div
                        class="form-field date-field"
                        style="margin-top: 0; width: 250px"
                      >
                        <label for="consent_date"
                          >Informed Consent Given Date</label
                        >
                        <input
                          type="date"
                          name="consent_date"
                          :disabled="$store.state.user.integration_id"
                          v-model="consent.given_date"
                        />
                      </div>
                      <button
                        class="button blue-button"
                        style="font-weight: bold; margin-bottom: 5px"
                        @click="submitConsent()"
                      >
                        Save Informed Consent
                      </button>
                    </div>

                    <div>
                      <div
                        class="field-checkbox"
                        style="display: flex; margin-top: 2em"
                      >
                        <Checkbox
                          inputId="aslr_consent"
                          :binary="true"
                          v-model="personalInformation.aslr_site_consent"
                        />
                        <label
                          style="
                            font-size: 1em;
                            padding-left: 10px;
                            font-weight: bold;
                          "
                          for="aslr_consent"
                        >
                          {{ $resident({ capitalize: true }) }} consents to
                          healthcare provider view access of their Active Script
                          List (if they are registered).
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'clinical'"
                >
                  <div class="personal-info-form-content">
                    <h3 style="margin: 0">Clinical Details</h3>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name">Height (cm)</label>
                        <input
                          type="number"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="clinicalDetails.height_cm"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Weight (kg)</label>
                        <input
                          type="number"
                          name="first_name"
                          :disabled="$store.state.user.integration_id"
                          v-model="clinicalDetails.weight_kg"
                        />
                      </div>
                    </div>
                    <div style="display: flex">
                      <button
                        class="button green-button"
                        style="margin-top: 1em; font-weight: bold"
                        @click="saveClinicalDetails()"
                      >
                        Save Clinical Details
                      </button>
                    </div>
                  </div>
                  <hr
                    style="
                      margin: 20px 0;
                      border: 0;
                      border-top: 1px solid #ccc;
                    "
                  />
                  <div class="adr-info-form-content">
                    <h3 style="margin: 0">
                      Allergies & Adverse Drug Reactions
                    </h3>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 5px;
                      "
                    >
                      <Checkbox
                        inputId="nkda"
                        v-model="nkda"
                        :binary="true"
                        @change="toggleNkda"
                      />
                      <label for="nkda" style="font-weight: bold"
                        >No Known Drug Allergies (NKDA)</label
                      >
                    </div>
                    <p
                      v-if="nkdaErrorMessage"
                      style="color: red; text-align: left; font-weight: bold; margin: 0 0 15px"
                    >
                      {{ nkdaErrorMessage }}
                    </p>
                    <div
                      v-if="nkda"
                      style="text-align: left; margin-bottom: 15px"
                    >
                      <span
                        >This {{ $resident() }} has been marked as having No
                        Known Drug Allergies.</span
                      >
                    </div>

                    <p style="text-align: left">
                      Enter any applicable allergies/drugs below:
                    </p>
                    <p
                      v-if="adrErrorMessage"
                      style="color: red; text-align: left; font-weight: bold"
                    >
                      {{ adrErrorMessage }}
                    </p>
                    <div>
                      <div style="max-height: 38em; overflow-y: auto">
                        <div
                          v-for="(item, index) in untitled.adr"
                          :key="index"
                          :style="{
                            position: 'relative',
                            display: 'grid',
                            'grid-template-columns': 'repeat(3, 1fr)',
                            gap: '5px',
                            'margin-bottom': '20px',
                            padding: '15px',
                            'padding-right': '40px',
                            border: isUnresolvedAdrDrugName(item) ? '1px solid #ef4444' : '1px solid #e2e8f0',
                            'border-radius': '6px',
                            opacity: item.status === 'Resolved' ? 0.55 : 1,
                          }"
                        >
                         <div class="form-field text-field" style="margin: 0">
                            <label>Custom / Other Substance</label>
                            <input
                              type="text"
                              v-model="item.custom"
                              placeholder="Enter substance name"
                            />
                          </div>
                          <div class="form-field text-field" style="margin: 0">
                            <label>Drug Name</label>
                            <DrugSearchInput
                              v-model="item.drug_name"
                              v-model:aliasValue="item.drug"
                              :showTabs="false"
                            />
                            <span
                              v-if="isUnresolvedAdrDrugName(item)"
                              style="color: #ef4444; font-size: 0.85em"
                            >
                              Please choose a drug from the dropdown list, or clear this
                              field and use "Custom / Other Substance" instead.
                            </span>
                          </div>
                         
                          <div class="form-field text-field" style="margin: 0">
                            <label>Reaction Description</label>
                            <input type="text" v-model="item.description" />
                          </div>
                          <div class="form-field text-field" style="margin: 0">
                            <label>Type of Reaction</label>
                            <Dropdown
                              v-model="item.reaction_type"
                              :options="reaction_types"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select Type"
                            />
                          </div>
                          <div class="form-field text-field" style="margin: 0">
                            <label>Severity</label>
                            <Dropdown
                              v-model="item.severity"
                              :options="severity_levels"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select Severity"
                            />
                          </div>
                          <div class="form-field text-field" style="margin: 0">
                            <label>Status</label>
                            <Dropdown
                              v-model="item.status"
                              :options="adr_statuses"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select Status"
                            />
                          </div>
                          <div class="form-field date-field" style="margin: 0">
                            <label>Date Reaction Last Occurred</label>
                            <input type="date" v-model="item.date" />
                          </div>
                          <i
                            @click="removeADR(index)"
                            style="
                              position: absolute;
                              top: 15px;
                              right: 15px;
                              cursor: pointer;
                              font-size: 1.2em;
                              color: #ef4444;
                            "
                            class="pi pi-trash"
                          ></i>
                        </div>
                      </div>
                      <div
                        style="
                          display: flex;
                          gap: 15px;
                          align-items: center;
                          margin-top: 10px;
                        "
                      >
                        <div
                          class="button outline-button"
                          @click="addNewADR"
                          style="margin: 0; padding: 10px 20px"
                        >
                          <p
                            style="
                              margin: 0;
                              display: flex;
                              align-items: center;
                              gap: 15px;
                            "
                          >
                            Add Another ADR
                            <span style="font-size: 1.2em">+</span>
                          </p>
                        </div>
                        <button
                          class="button green-button"
                          style="
                            display: flex;
                            align-items: center;
                            padding: 10px 20px;
                          "
                          @click="submitADR()"
                        >
                          Save List
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr
                    style="
                      margin: 20px 0;
                      border: 0;
                      border-top: 1px solid #ccc;
                    "
                  />
                  <h3 style="margin: 0">Special Considerations</h3>
                  <div
                    class="considerations-info-form-content"
                    style="
                      display: grid;
                      grid-template-columns: 1fr 1fr;
                      grid-gap: 20px;
                      width: 80%;
                    "
                  >
                    <div>
                      <div class="special-considerations-form-container">
                        <h4 style="text-align: left; font-weight: 500">
                          Medication Method
                        </h4>
                        <div class="special-considerations-form">
                          <div class="spec-cons-items">
                            <div
                              class="spec-cons-item"
                              v-for="(item, index) in medication_methods"
                              :key="index"
                            >
                              <input
                                type="checkbox"
                                name="inactive"
                                @change="saveSelectedItem(item)"
                                :checked="
                                  untitled.special_considerations.includes(item)
                                "
                              />
                              <label for="inactive">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="special-considerations-form-container">
                        <h4 style="text-align: left; font-weight: 500">
                          Medication Administration
                        </h4>
                        <div class="special-considerations-form">
                          <div class="spec-cons-items">
                            <div
                              class="spec-cons-item"
                              v-for="(item, index) in medication_administration"
                              :key="index"
                            >
                              <input
                                type="checkbox"
                                name="inactive"
                                @change="saveSelectedItem(item)"
                                :checked="
                                  untitled.special_considerations.includes(item)
                                "
                              />
                              <label for="inactive">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="special-considerations-form-container">
                        <h4 style="text-align: left; font-weight: 500">
                          Patient Considerations
                        </h4>
                        <div class="special-considerations-form">
                          <div class="spec-cons-items">
                            <div
                              class="spec-cons-item"
                              v-for="(item, index) in patient_considerations"
                              :key="index"
                            >
                              <input
                                type="checkbox"
                                name="inactive"
                                @change="saveSelectedItem(item)"
                                :checked="
                                  untitled.special_considerations.includes(item)
                                "
                              />
                              <label for="inactive">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                      "
                    >
                      <div class="special-considerations-form-container">
                        <h4 style="text-align: left; font-weight: 500">
                          Medication Delivery
                        </h4>
                        <div class="special-considerations-form">
                          <div class="spec-cons-items">
                            <div
                              class="spec-cons-item"
                              v-for="(item, index) in medication_delivery"
                              :key="index"
                            >
                              <input
                                type="checkbox"
                                name="inactive"
                                @change="saveSelectedItem(item)"
                                :checked="
                                  untitled.special_considerations.includes(item)
                                "
                              />
                              <label for="inactive">{{
                                item == "Resident/patient hand"
                                  ? $resident({ capitalize: true }) +
                                    "/patient hand"
                                  : item
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="special-considerations-form-container">
                        <h4
                          style="
                            text-align: left;
                            font-weight: 500;
                            margin-bottom: 0;
                          "
                        >
                          Specific Instructions/Additional Comments
                        </h4>
                        <p style="margin-top: 0; text-align: left">
                          Note here if other medication
                          methods/administration/delivery or patient
                          considerations.
                        </p>
                        <div class="special-considerations-form">
                          <textarea
                            name="spec-cons-notes"
                            id="spec-cons-notes"
                            v-model="untitled.special_considerations_notes"
                            style="max-width: 95%; box-sizing: border-box"
                            cols="60"
                            rows="10"
                          ></textarea>
                        </div>
                      </div>
                      <button
                        class="green-button"
                        style="width: fit-content; align-self: flex-end"
                        @click="submitSpecCons()"
                      >
                        Save Special Considerations
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'contact_details'"
                >
                  <div class="contact-info-form-content">
                    <h3 style="margin: 0">Contact Details</h3>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name">
                          Address
                          <span v-if="!isSimplified" style="color: red">*</span>
                          {{
                            patient.address
                              ? ": " +
                                patient.address.street_address +
                                ", " +
                                patient.address.suburb +
                                ", " +
                                patient.address.postcode
                              : ""
                          }}
                        </label>
                        <div class="form-field text-field">
                          <vue-google-autocomplete
                            id="contactmap"
                            classname="form-control"
                            :placeholder="
                              patient.address
                                ? patient.address.street_address
                                : ''
                            "
                            v-on:placechanged="getPersonalAddressData"
                            :country="$store.state.country"
                          >
                          </vue-google-autocomplete>
                        </div>
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Phone</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="untitled.phone"
                        />
                        <!-- <InputMask  v-model="untitled.phone" unmask=unmask style="background-color: #f3f4f4" mask="(99) 9999 9999" 
                                         placeholder="(03) 9999 9999"/> -->
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Email</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="untitled.email"
                        />
                      </div>
                    </div>
                  </div>
                  <div style="display: flex">
                    <button
                      class="button green-button"
                      style="margin-top: 1em"
                      @click="editContactDetails()"
                    >
                      Update Contact Details
                    </button>
                  </div>
                  <div class="contact-info-form-content">
                    <h3>Next of Kin Details</h3>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name">Next of Kin - First name</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="kin.first_name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Next of Kin - Last name</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="kin.last_name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name"
                          >Next of Kin - Relationship</label
                        >
                        <input
                          type="text"
                          name="first_name"
                          v-model="kin.relationship"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Next of Kin - Phone</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="kin.phone"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Next of Kin - Email</label>
                        <input
                          type="text"
                          name="first_name"
                          v-model="kin.email"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="validationError"
                    style="
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                    "
                  >
                    <p
                      style="font-size: 1em; text-align: left; color: red"
                      v-if="validationError"
                    >
                      {{ validationErrorMessage }}
                    </p>
                  </div>
                  <div style="display: flex">
                    <button
                      class="button green-button"
                      style="margin-top: 1em"
                      @click="editNextOfKin()"
                    >
                      Update Next of Kin
                    </button>
                  </div>
                </div>
                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'regulatory_numbers'"
                >
                  <div class="contact-info-form-content">
                    <h3>Entitlement & Regulatory Numbers</h3>
                    <div class="form-fields">
                      <div
                        class="form-field text-field"
                        v-if="medicareIndex !== -1"
                        style="position: relative"
                      >
                        <label for="first_name"
                          >Medicare Number
                          <span style="color: red">*</span></label
                        >
                        <InputText
                          class="p-inputtext p-component"
                          style="background-color: #f3f4f4; width: 100%"
                          v-model="regulatory_numbers[medicareIndex].data"
                          @blur="medicareTouched = true"
                          @input="formatMedicareInput('edit')"
                          placeholder="9999 99999 9 / 9(IRN)"
                        />
                        <small
                          v-show="
                            regulatory_numbers[medicareIndex].data &&
                            (medicareTouched ||
                              regulatory_numbers[medicareIndex].data.replace(
                                /\D/g,
                                '',
                              ).length >= 10) &&
                            !validMedicareNumber
                          "
                          style="
                            color: red;
                            position: absolute;
                            bottom: -18px;
                            left: 0;
                            white-space: nowrap;
                          "
                          >Invalid Medicare Number format.</small
                        >
                      </div>
                      <div
                        class="form-field text-field"
                        v-if="medicareIndex !== -1"
                        style="position: relative"
                      >
                        <label for="first_name"
                          >Medicare Expiry
                          <span style="color: red">*</span></label
                        >
                        <Calendar
                          id="monthpicker"
                          v-model="regulatory_numbers[medicareIndex].expiry"
                          view="month"
                          dateFormat="mm/yy"
                          :yearNavigator="true"
                          yearRange="2020:2050"
                          style="width: 100%"
                          inputStyle="background-color: #f3f4f4; width: 100%;"
                        />
                        <small
                          v-show="
                            regulatory_numbers[medicareIndex].expiry &&
                            !validMedicareExpiry
                          "
                          style="
                            color: red;
                            position: absolute;
                            bottom: -18px;
                            left: 0;
                            white-space: nowrap;
                          "
                          >Expiry date must be in the future.</small
                        >
                      </div>
                      <div
                        class="form-field text-field"
                        v-if="dvaIndex !== -1"
                        style="position: relative"
                      >
                        <label for="first_name">DVA Number</label>
                        <input
                          type="text"
                          style="width: 100%"
                          v-model="regulatory_numbers[dvaIndex].data"
                        />
                        <small
                          v-show="
                            regulatory_numbers[dvaIndex].data && !validDVANumber
                          "
                          style="
                            color: red;
                            position: absolute;
                            bottom: -18px;
                            left: 0;
                            white-space: nowrap;
                          "
                          >Invalid DVA Number format.</small
                        >
                      </div>
                      <div class="form-field text-field" v-if="dvaIndex !== -1">
                        <label for="first_name">DVA Status </label>
                        <Dropdown
                          v-model="regulatory_numbers[dvaIndex].regulatory_type"
                          :options="dva_statuses"
                          optionLabel="status"
                          optionValue="value"
                          placeholder="Select DVA Status"
                        />
                      </div>
                      <div
                        class="form-field text-field"
                        v-if="dvaIndex !== -1"
                        style="position: relative"
                      >
                        <label for="first_name">DVA Expiry</label>
                        <Calendar
                          id="dvamonthpicker"
                          v-model="regulatory_numbers[dvaIndex].expiry"
                          view="month"
                          dateFormat="mm/yy"
                          :yearNavigator="true"
                          yearRange="2020:2050"
                          style="width: 100%"
                          inputStyle="background-color: #f3f4f4; width: 100%;"
                        />
                        <small
                          v-show="
                            regulatory_numbers[dvaIndex].expiry &&
                            !validDVAExpiry
                          "
                          style="
                            color: red;
                            position: absolute;
                            bottom: -18px;
                            left: 0;
                            white-space: nowrap;
                          "
                          >Expiry date must be in the future.</small
                        >
                        <small
                          v-show="
                            regulatory_numbers[dvaIndex].expiry &&
                            !regulatory_numbers[dvaIndex].data
                          "
                          style="
                            color: red;
                            position: absolute;
                            bottom: -18px;
                            left: 0;
                            white-space: nowrap;
                          "
                          >DVA Number is required to save DVA Expiry.</small
                        >
                      </div>
                      <div
                        class="form-field text-field"
                        v-for="(item, index) in grouped_regulatory_numbers"
                        :key="index"
                      >
                        <label for="first_name">{{
                          item.regulatory_type
                        }}</label>
                        <input
                          type="text"
                          name="first_name"
                          :placeholder="item.data"
                          v-model="item.data"
                        />
                      </div>
                    </div>
                  </div>
                  <div style="display: flex">
                    <button
                      class="button green-button"
                      style="margin-top: 1em"
                      @click="editEntitlementNumbers()"
                    >
                      Update Entitlement & Regulatory Numbers
                    </button>
                  </div>
                  <div
                    style="
                      margin-top: 20px;
                      padding-top: 20px;
                      border-top: 1px solid #e2e8f0;
                      margin-bottom: 20px;
                    "
                    v-if="$store.state.user.eprescribing_active"
                  >
                    <h3 style="margin: 0; margin-bottom: 10px">
                      IHI Number
                      <span
                        v-if="ihiDetails && ihiDetails.last_checked"
                        style="
                          font-size: 0.85em;
                          font-weight: normal;
                          margin-left: 10px;
                        "
                        >(Last checked: {{ ihiDetails.last_checked }})</span
                      >
                      <span
                        style="
                          font-size: 0.9em;
                          font-weight: normal;
                          color: green;
                        "
                        v-if="!ihiDetails"
                        >[Please wait while we retrieve the IHI Number...]</span
                      >
                    </h3>
                    <p
                      style="
                        margin: 0;
                        font-size: 0.9em;
                        text-align: left;
                        margin-bottom: 15px;
                      "
                    >
                      Fill in the {{ $resident() }}'s name, sex, DOB,
                      Medicare/DVA Number to retrieve IHI Number.
                    </p>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name">IHI Number</label>
                        <InputMask
                          style="background-color: #f3f4f4"
                          mask="9999 9999 9999 9999"
                          v-model="ihiDetails.number"
                          placeholder="9999 9999 9999 9999"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">IHI Number Status</label>
                        <inputText
                          class="grey-input-color"
                          disabled
                          type="text"
                          name="first_name"
                          :value="ihiDetails.ihi_status"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">IHI Record Status</label>
                        <inputText
                          class="grey-input-color"
                          disabled
                          type="text"
                          name="first_name"
                          :value="ihiDetails.ihi_record_status"
                        />
                      </div>
                    </div>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin-top: 10px;
                      "
                    >
                      <button
                        class="button green-button"
                        style="font-weight: bold; margin-right: 10px"
                        @click="validateIHINumber(true)"
                      >
                        Validate IHI Number
                      </button>

                      <button
                        @click="displayIHIHistoryModal = true"
                        class="button outline-button"
                      >
                        View IHI Number History
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'prescriber_details'"
                >
                  <div
                    class="prescriber-info-form-content"
                    style="display: grid"
                  >
                    <div
                      style="display: flex; gap: 20px; flex-direction: column"
                    >
                      <!-- left -->
                      <div>
                        <h3 style="margin: 0">Primary Prescriber</h3>
                        <p
                          v-if="selectedPrescriber"
                          style="font-size: 1em; text-align: left"
                        >
                          Current Primary Prescriber:
                          <b>{{ selectedPrescriber.name }}</b>
                        </p>
                        <div style="display: flex; flex-direction: column">
                          <p
                            v-if="!selectedPrescriber"
                            style="font-size: 1em; text-align: left; margin: 0"
                          >
                            Select prescriber to link to {{ $resident() }}:
                          </p>
                          <p
                            v-else
                            style="font-size: 1em; text-align: left; margin: 0"
                          >
                            Change primary prescriber:
                          </p>
                          <div
                            style="
                              display: flex;
                              gap: 20px;
                              align-items: center;
                            "
                          >
                            <Dropdown
                              v-model="selectedPrescriber"
                              :options="prescribers"
                              optionLabel="name"
                              :placeholder="loadingPrescribers ? 'Loading prescribers...' : 'Select Prescriber'"
                              :disabled="loadingPrescribers"
                              emptyMessage="No prescribers registered for this facility."
                              style="width: fit-content; margin-top: 10px"
                            />
                            <div
                              v-if="
                                $store.state.userType != 'prescriber' &&
                                $store.state.userType != 'pharmacy'
                              "
                            >
                              <button
                                style="margin-top: 10px"
                                class="button green-button"
                                @click="submitPrescriber(false)"
                              >
                                Update Primary GP
                              </button>
                            </div>
                          </div>
                          <p
                            v-if="!loadingPrescribers && (!prescribers || !prescribers.length)"
                            style="font-size: 1em; text-align: left; margin: 5px 0 0"
                          >
                            No prescribers registered for this facility yet.
                            <router-link to="/settings" style="color: #0870DC; text-decoration: underline;">
                              Register or link one in Settings &rarr; Prescribers.
                            </router-link>
                          </p>
                        </div>
                      </div>
                      <!-- right -->
                      <div>
                        <h3 style="margin: 0">Additional Prescribers</h3>
                        <div>
                          <div style="display: flex; flex-direction: column">
                            <div
                              style="
                                display: flex;
                                gap: 20px;
                                align-items: center;
                              "
                            >
                              <Dropdown
                                v-model="additional_prescriber"
                                :options="additionalPrescribers"
                                optionLabel="name"
                                :placeholder="loadingPrescribers ? 'Loading prescribers...' : 'Select Prescriber'"
                                :disabled="loadingPrescribers"
                                emptyMessage="No prescribers registered for this facility."
                                style="width: fit-content; margin-top: 10px"
                              />
                              <div
                                v-if="
                                  $store.state.userType != 'prescriber' &&
                                  $store.state.userType != 'pharmacy'
                                "
                              >
                                <button
                                  style="margin-top: 10px"
                                  class="button green-button"
                                  @click="submitPrescriber(true)"
                                >
                                  Add additional GP
                                </button>
                              </div>
                            </div>
                          </div>
                          <p
                            style="
                              text-align: left;
                              font-size: 1em;
                              font-weight: bold;
                            "
                          >
                            Currently linked prescribers:
                          </p>
                          <div
                            style="
                              overflow-y: auto;
                              overflow-x: hidden;
                              height: 170px;
                              max-width: 400px;
                              border: 1px solid #e2e8f0;
                              background-color: #f8fafc;
                              padding: 10px;
                              border-radius: 8px;
                            "
                          >
                            <div v-if="facilitiesPrescribers?.length > 0">
                              <table>
                                <tr
                                  v-for="(gp, index) in facilitiesPrescribers"
                                  :key="index"
                                >
                                  <!-- name -->
                                  <td style="width: 300px">
                                    {{ gp.personal_information.first_name }}
                                    {{ gp.personal_information.last_name }}
                                  </td>
                                  <!-- primary presiber tag -->
                                  <td
                                    style="
                                      display: flex;
                                      justify-content: right;
                                    "
                                  >
                                    <div>
                                      <button
                                        class="button red-button"
                                        @click="unlinkPrescriber(gp)"
                                      >
                                        Unlink
                                      </button>
                                    </div>
                                    <!-- <div v-if="(!(patient.prescribers.map(item => item.uuid)).includes(gp.uuid)) && (patient.primary_prescriber.uuid != gp.uuid)"><button class="button green-button" @click="linkPrescriber(gp)">Link</button> </div> -->
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div v-else>
                              <p>
                                No additional prescribers linked to this
                                patient.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="prescriber-info-form-content"
                    style="display: grid; margin-top: 1em"
                  >
                    <h3>Pharmacy Details</h3>
                    <p
                      v-if="selectedPharmacy"
                      style="font-size: 1em; text-align: left"
                    >
                      Current Pharmacy: <b>{{ selectedPharmacy.name }}</b>
                    </p>
                    <div
                      v-if="pharmacies && pharmacies.length"
                      style="display: flex; flex-direction: column"
                    >
                      <p
                        v-if="!selectedPharmacy"
                        style="font-size: 1em; text-align: left; margin: 0"
                      >
                        Select pharmacy to link to {{ $resident() }}:
                      </p>
                      <p
                        v-else
                        style="font-size: 1em; text-align: left; margin: 0"
                      >
                        Change pharmacy:
                      </p>
                      <div
                        style="display: flex; gap: 20px; align-items: center"
                      >
                        <Dropdown
                          v-model="selectedPharmacy"
                          :options="pharmacies"
                          optionLabel="name"
                          placeholder="Select Pharmacy"
                          style="width: fit-content"
                        />
                        <button
                          class="button green-button"
                          @click="submitPharmacy()"
                          v-if="
                            $store.state.userType != 'prescriber' &&
                            $store.state.userType != 'pharmacy'
                          "
                        >
                          Update Pharmacy
                        </button>
                      </div>
                    </div>

                    <p
                      style="
                        text-align: left;
                        font-size: 1em;
                        font-weight: bold;
                      "
                    >
                      Visible to the following Pharmacies:
                    </p>
                    <div
                      style="
                        overflow-y: auto;
                        overflow-x: hidden;
                        height: 170px;
                        max-width: 400px;
                        border: 1px solid #e2e8f0;
                        background-color: #f8fafc;
                        padding: 10px;
                        border-radius: 8px;
                      "
                    >
                      <div>
                        <table>
                          <tr
                            v-for="(
                              pharmacy, index
                            ) in patient.latest_pharmacies"
                            :key="index"
                          >
                            <td style="width: 100%">{{ pharmacy.name }}</td>
                            <td
                              style="display: flex; justify-content: right"
                              v-if="
                                $store.state.userType != 'prescriber' &&
                                $store.state.userType != 'pharmacy'
                              "
                            >
                              <div>
                                <button
                                  class="button red-button"
                                  @click="
                                    unlinkPharmacy(pharmacy.satellite_uuid)
                                  "
                                >
                                  Unlink
                                </button>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div
                    class="prescriber-info-form-content"
                    v-for="(prescriber, pi) in untitled.prescribers"
                    :key="pi"
                  >
                    <h3>Prescriber Details (not Primary GP)</h3>
                    <div style="display: flex; align-items: center">
                      <div
                        class="text-search-container search-container text-field"
                        style="
                          display: flex;
                          flex-direction: column;
                          margin-top: 0.25em;
                          margin-right: 20px;
                          position: relative;
                        "
                      >
                        <label
                          for="first_name"
                          style="text-align: left; padding-left: 10px"
                          >Search by Prescriber Number</label
                        >
                        <input
                          v-model="nonGP"
                          v-on:keyup="debounceGpSearch(nonGP)"
                          @keyup.enter="debounceGpSearch.clear(), gpSearch(nonGP)"
                          placeholder="Search Prescriber No."
                          style="
                            position: relative;
                            border: 3px solid rgb(202, 202, 202);
                            background-color: white;
                          "
                        />
                        <div
                          class="drug-search-result-container"
                          v-if="nonGP"
                          style="
                            position: absolute;
                            margin-top: 55px;
                            background-color: white;
                            width: 20em;
                            border: 2px solid #f6f6f6;
                          "
                        >
                          <p
                            class="drug-search-result"
                            style="
                              text-align: left;
                              padding-left: 20px;
                              cursor: pointer;
                            "
                            v-for="(item, index) in prescriberResults"
                            :key="index"
                            @click="selectPrescriber(item)"
                          >
                            {{ item.prescriber_number }}
                          </p>
                        </div>
                      </div>
                      <p
                        style="
                          text-align: left;
                          margin-left: 20px;
                          cursor: pointer;
                          width: fit-content;
                          margin: 0;
                          margin-top: 20px;
                          border-bottom: 1px solid grey;
                        "
                        v-if="prescriber.uuid"
                        @click="clearPrescriber"
                      >
                        Clear Selected Prescriber
                      </p>
                    </div>
                    <div class="form-fields">
                      <div class="form-field text-field">
                        <label for="first_name">Prescriber Number</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          v-model="prescriber.prescriber_number"
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.prescriber_number"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Name</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          :value="
                            prescriber.first_name + ' ' + prescriber.last_name
                          "
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.name"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Phone</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          v-model="prescriber.phone"
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.phone"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">After Hours Phone</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          v-model="prescriber.after_hours"
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.after_hours"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Address</label>
                        <vue-google-autocomplete
                          v-if="!prescriber.uuid"
                          id="prescriberaddress"
                          classname="form-control"
                          placeholder=""
                          v-on:placechanged="getAddressData('prescriber')"
                          :country="$store.state.country"
                        >
                        </vue-google-autocomplete>
                        <input
                          v-else
                          type="text"
                          v-model="prescriber.address"
                          disabled
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Email</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          v-model="prescriber.email"
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.email"
                        />
                      </div>
                      <div class="form-field text-field">
                        <label for="first_name">Fax Number</label>
                        <input
                          v-if="prescriber.uuid"
                          type="text"
                          v-model="prescriber.fax"
                          disabled
                        />
                        <input
                          v-else
                          type="text"
                          name="first_name"
                          v-model="prescriber.fax"
                        />
                      </div>
                    </div>
                    <div style="display: flex">
                      <button
                        class="button green-button"
                        style="margin-top: 1em"
                        @click="removeAndReplaceGP()"
                      >
                        Update Prescriber
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="patient-form-content-section patient-card"
                  v-if="selectedNavigation == 'vaccinations'"
                >
                  <div class="vac-weight-info-form-content">
                    <h3>Vaccination History</h3>
                    <div class="vac-weight-table">
                      <table>
                        <tr>
                          <th>Vaccine</th>
                          <th>Date Last Given</th>
                          <th></th>
                        </tr>
                        <tr
                          v-for="(item, index) in untitled.vaccinations"
                          :key="index"
                        >
                          <td>
                            <input
                              type="text"
                              v-model="item.vaccine"
                              style="width: 95%"
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              v-model="item.date"
                              style="width: 95%"
                            />
                          </td>
                          <td>
                            <i
                              @click="removeVaccine(index)"
                              style="
                                cursor: pointer;
                                font-size: 1.2em !important;
                              "
                              class="pi pi-trash"
                            ></i>
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div class="button outline-button" @click="addNewVaccine">
                      <p>
                        Add Another Vaccination Record &nbsp; &nbsp; &nbsp;
                        <span style="font-size: 1.2em">+</span>
                      </p>
                    </div>
                  </div>
                  <div class="vac-weight-info-form-content">
                    <h3>Weights</h3>
                    <div class="vac-weight-table">
                      <table>
                        <tr>
                          <th>Weights</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                        <tr
                          v-for="(item, index) in untitled.weights"
                          :key="index"
                        >
                          <td>
                            <input
                              type="text"
                              v-model="item.weight"
                              style="width: 95%"
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              v-model="item.date"
                              style="width: 95%"
                            />
                          </td>
                          <td>
                            <i
                              @click="removeWeight(index)"
                              style="
                                cursor: pointer;
                                font-size: 1.2em !important;
                              "
                              class="pi pi-trash"
                            ></i>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="button outline-button" @click="addNewWeight">
                      <p>
                        Add Another Weight Record &nbsp; &nbsp; &nbsp;
                        <span style="font-size: 1.2em">+</span>
                      </p>
                    </div>
                  </div>
                </div>
                <!-- FORM BUTTONS -->
                <!-- <div style="display:flex; align-items: center; justify-content: flex-end; align-self: flex-end">
                                    <button class="button" @click="nextFormPage" v-if="selectedNavigation != 'considerations' && (!this.$store.state.user.enmrc_eprescribing_active ? selectedNavigation != 'contact_details' : true)"
                                        style="margin: 0; padding: 0 10px; width: 10em; background-color: #0870DC; color: white;">Next</button>
                                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadingPatient"
          class="panel-content-container patient-form"
          style="display: flex"
        >
          <div style="width: 100%; margin-top: 5em">
            <p style="font-size: 1em; font-weight: bold">
              Loading {{ $resident({ capitalize: true }) }}...
            </p>
            <i
              class="pi pi-spin pi-spinner"
              style="font-size: 2rem !important"
            ></i>
          </div>
        </div>
        <SuccessModal
          v-if="displaySuccessModal"
          @close="close"
          :loading="loading"
          :statusMessage="statusMessage"
          :message="successMessage"
          :first_spec_line="errActions ? errActions : first_spec_line"
          :second_spec_line="second_spec_line"
          :style="{ color: errActions ? 'red' : '' }"
        />
        <IHIHistoryModal
          v-if="displayIHIHistoryModal"
          @close="close"
          :patientID="$route.params.id"
        />
        <IHIConflictModal
          v-if="displayIHIConflictModal"
          @close="close"
          :personalInformation="personalInformation"
          :conflictPatients="
            ihiDetails.conflicts && ihiDetails.conflicts.length
              ? ihiDetails.conflicts
              : ''
          "
        />
        <ConfirmationModal
          v-if="displaySimilarNameModal"
          :actionDescription="similarNameWarningMessage"
          acceptText="Submit"
          rejectText="Cancel"
          @close="onSimilarNameModalCancelled"
          @accepted="onSimilarNameModalAccepted"
        />
      </div>
      <div v-else>
        <div
          class="drug-register-table table-container"
          style="
            padding-top: 5em;
            width: fit-content;
            height: 20em;
            box-shadow: none;
            margin: 0 auto;
          "
        >
          <h4
            style="
              border: 2px solid black;
              border-bottom: 2px solid black;
              width: fit-content;
              height: fit-content;
              margin: 0 auto;
              padding: 5px;
              border-radius: 4px;
            "
          >
            You do not have permission to access this feature. Please talk to
            your admin if you require access.
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import IHIHistoryModal from "@/components/modals/IHIHistoryModal.vue";
import IHIConflictModal from "@/components/modals/IHIConflictModal.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import DrugSearchInput from "@/components/DrugSearchInput.vue";
import { debounceSearch } from "@/services/debounce";
import { getRealAdrs, isNkdaEntry } from "@/services/nkda";
import {
  formatMedicareNumber,
  formatExpiryForSubmit as formatExpiry,
  isSimplifiedOnboarding,
  validateExpiryInFuture,
  validateMedicareNumber as isValidMedicareNumber,
  validateDVANumber as isValidDVANumber,
} from "@/services/patientValidation";
import {
  buildPatientProfileTabs,
  resolvePatientProfileTab,
} from "@/services/patientProfileTabs";

export default {
  components: {
    SuccessModal,
    IHIHistoryModal,
    IHIConflictModal,
    ConfirmationModal,
    DrugSearchInput,
  },
  data() {
    return {
      // Assigned in created() rather than declared in methods - see services/debounce.js.
      debounceGpSearch: null,
      validationError: false,
      validationErrorMessage: "",
      statusOptions: [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "Onboarding", value: "onboarding" },
      ],
      selectedStatus: "",
      additionalPrescribers: [],
      errorDOB: false,
      loadingPatient: false,
      loadingLocations: false,
      selectedFacility: "",
      successMessage: "",
      facilities: [],
      facilitiesPrescribers: [],
      additional_prescriber: "",
      nodes: [],
      selectedNodeKey: "",
      adrErrorMessage: "",
      // Snapshot of each persisted ADR row's comparable fields, keyed by uuid, taken at load
      // time (and refreshed after every successful save). Kraken's /patient/:uuid/adr endpoint
      // has no update-by-uuid path - every call is a pure insert - so submitADR() uses this to
      // work out which rows actually changed and only recreate those, instead of blowing away
      // and recreating every ADR on every save.
      adrPristineSnapshot: {},
      nkdaErrorMessage: "",
      errActions: "",
      statusMessage: "Updating Patient",
      displaySuccessModal: false,
      displayIHIHistoryModal: false,
      displayIHIConflictModal: false,
      loading: false,
      first_spec_line: "",
      second_spec_line: "",
      somelocation: "",
      selectedNavigation: "personal_information",
      gp: "",
      nonGP: "",
      patientUUID: "",
      pharmacySearchInput: "",
      validForm: false,
      prescriberResults: [],
      pharmacyResults: [],
      // Only the tabs this site has - hospital (non-eNMRC) sites get the same
      // sections as aged care, minus the ePrescribing-only prescriber/pharmacy
      // tab. See @/services/patientProfileTabs.
      navigationItems: buildPatientProfileTabs(this.$store),
      personalInformation: {
        first_name: "",
        last_name: "",
        preferred_name: "",
        sex: "",
        dob: "",
        tag: [],
        aslr_site_consent: true,
        similar_sounding_name: false,
      },
      clinicalDetails: {
        height_cm: "",
        weight_kg: "",
      },
      regulatory_numbers: [],
      address: {
        street_address: "",
        country: "",
        postcode: "",
        suburb: "",
        city: "",
      },
      facility_location: {
        room_uuid: "",
      },
      kin: {
        first_name: "",
        last_name: "",
        relationship: "",
        phone: "",
        email: "",
      },
      untitled: {
        commencement_date: "",
        expiry_date: "",
        phone: "",
        phone_uuid: "",
        email: "",
        email_uuid: "",
        gp: {
          prescriber_number: "",
          uuid: "",
          name: "",
          phone: "",
          after_hours: "",
          address: "",
          email: "",
          fax: "",
          primary_gp: true,
        },
        pharmacy: {
          name: "",
          address: "",
          contact: "",
          phone: "",
          email: "",
          fax: "",
          uuid: "",
        },
        prescriber: {
          prescriber_number: "",
          uuid: "",
          name: "",
          phone: "",
          after_hours: "",
          address: "",
          email: "",
          fax: "",
          primary_gp: false,
        },

        prescribers: [],
        adr: [
          {
            custom: "",
            drug: null,
            description: "",
            reaction_type: "",
            severity: "",
            status: "Active",
            date: "",
          },
        ],
        special_considerations: [],
        special_considerations_notes: "",
        vaccinations: [
          {
            vaccine: "",
            date: "",
          },
        ],
        weights: [
          {
            weight: "",
            date: "",
          },
        ],
      },
      // SPECIAL CONSIDERATION OPTIONS
      medication_methods: [
        "Whole",
        "Quartered",
        "Dissolved",
        "Halved",
        "Capsule opened",
        "Crushed and mixed with...",
      ],
      medication_administration: ["Water", "Thickened fluids"],
      patient_considerations: [
        "Swallowing difficulty",
        "Cognitive impairment",
        "Resistive to medication",
        "Self administers",
        "Crush medications",
        "Dexterity issues",
        "Nil by mouth",
      ],
      medication_delivery: [
        "Teaspoon - staff guide",
        "Medication cup",
        "Resident/patient hand",
        "PEG administration",
      ],
      // LOCATION DETAILS
      parentLocation: "",
      locationName: [],
      childLocations: [],
      previewImage: null,
      originalGPID: "",
      patient: {},
      pharmacies: [],
      selectedPharmacy: "",
      prescribers: [],
      loadingPrescribers: false,
      selectedPrescriber: "",
      ihiDetails: {
        number: "",
        ihi_status: "",
        ihi_record_status: "",
      },
      initialContact: {
        phone: "",
        email: "",
      },
      editDob: "",
      currMedicare: "",
      currDVA: "",
      dva_statuses: [
        { status: "None", value: "DVA Number" },
        { status: "Gold", value: "DVA Gold" },
        { status: "White", value: "DVA White" },
        { status: "Orange", value: "DVA Orange" },
      ],
      sex: [
        { sex: "Male" },
        { sex: "Female" },
        { sex: "Intersex" },
        { sex: "Unknown" },
      ],
      consent: {
        has_consented: false,
        given_by: "",
        given_date: "",
        consent_type: "psychotropic",
      },
      consentTypeOptions: [
        { label: "Psychotropic", value: "psychotropic" },
        { label: "Prescribing", value: "prescribing" },
      ],
      psychotropicConsent: null,
      prescribingConsent: null,
      medicareTouched: false,
      displaySimilarNameModal: false,
      similarNameWarningMessage: "",
      nkda: false,
      // uuid of the NKDA assertion Adr record (if one currently exists), needed to delete it
      // when the user unchecks NKDA.
      nkdaUuid: null,
      severity_levels: [
        { label: "Mild", value: "Mild" },
        { label: "Moderate", value: "Moderate" },
        { label: "Severe", value: "Severe" },
      ],
      reaction_types: [
        { label: "Rash", value: "Rash" },
        { label: "Anaphylaxis", value: "Anaphylaxis" },
        { label: "Nausea/Vomiting", value: "Nausea/Vomiting" },
        { label: "Swelling", value: "Swelling" },
        { label: "Itching", value: "Itching" },
        { label: "Respiratory Distress", value: "Respiratory Distress" },
        { label: "Diarrhea", value: "Diarrhea" },
        { label: "Other", value: "Other" },
      ],
      adr_statuses: [
        { label: "Active", value: "Active" },
        { label: "Resolved", value: "Resolved" },
      ],
    };
  },
  created() {
    this.debounceGpSearch = debounceSearch((query) => this.gpSearch(query));
  },
  methods: {
    checkSimilarNames() {
      if (
        !this.personalInformation.first_name ||
        !this.personalInformation.last_name
      ) {
        return Promise.resolve([]);
      }

      let facilityUuid = this.$store.state.currentLocation?.facility?.uuid;

      if (
        !facilityUuid &&
        this.patient?.facilities &&
        this.patient.facilities.length > 0
      ) {
        facilityUuid = this.patient.facilities[0].uuid;
      }

      if (
        !facilityUuid &&
        this.patient?.physical_location?.location?.facility?.uuid
      ) {
        facilityUuid = this.patient.physical_location.location.facility.uuid;
      }

      if (!facilityUuid) {
        console.log("checkSimilarNames aborted: no facilityUuid found");
        return Promise.resolve([]);
      }

      return axios
        .post(
          `/facility/${facilityUuid}/similar-sounding-names`,
          {
            first_name: this.personalInformation.first_name,
            last_name: this.personalInformation.last_name,
          },
          this.$store.state.header,
        )
        .then((res) => {
          // Normalize the response data to an array
          let matches = [];
          if (Array.isArray(res.data)) {
            matches = res.data;
          } else if (res.data && typeof res.data === "object") {
            matches = Object.values(res.data);
          }

          // Filter out the current patient so they aren't matched against themselves
          let currentUuid =
            this.patientUUID || (this.patient && this.patient.uuid);
          if (currentUuid) {
            matches = matches.filter((m) => m.uuid !== currentUuid);
          }

          if (matches && matches.length > 0) {
            this.personalInformation.similar_sounding_name = true;
          }

          return matches;
        })
        .catch((err) => {
          console.error("Failed to check similar sounding names", err);
          return [];
        });
    },
    buildSimilarNameWarningMessage(matches) {
      const names = matches
        .map((m) => `${m.first_name || ""} ${m.last_name || ""}`.trim())
        .filter(Boolean);
      return `This ${this.$resident()}'s name sounds similar to another resident. Do you want to continue saving?`;
    },
    onSimilarNameModalAccepted() {
      this.displaySimilarNameModal = false;
      this.performPersonalInfoSave();
    },
    onSimilarNameModalCancelled() {
      this.displaySimilarNameModal = false;
    },
    formatMedicareInput(type) {
      const current = this.regulatory_numbers[this.medicareIndex].data;
      if (!current) return;
      if (type === "edit") {
        this.regulatory_numbers[this.medicareIndex].data =
          formatMedicareNumber(current);
      }
    },
    validateMedicareNumber(number) {
      return isValidMedicareNumber(number);
    },
    validateDVANumber(number) {
      return isValidDVANumber(number);
    },
    formatExpiryForSubmit(date) {
      return formatExpiry(date);
    },
    saveStatus() {
      if (this.selectedStatus) {
        this.displaySuccessModal = true;
        this.loading = true;
        axios
          .post(
            `/person/${this.patientUUID}/status`,
            { status: this.selectedStatus },
            this.$store.state.header,
          )
          .then((res) => {
            console.log("updated status", res);
            this.loading = false;
            this.successMessage = "Updated " + this.$resident() + " status.";
            this.$emit("changeStatus", this.selectedStatus);
          })
          .catch((err) => {
            this.loading = false;
            this.successMessage = `Error: ${err.response.data}`;
          });
      }
    },
    validateIHINumber(clicked) {
      let payload = {};
      if (
        this.medicare_num &&
        this.medicare_num.length &&
        this.currMedicare != this.medicare_num[0].data
      ) {
        console.log(
          "this is the medicare match",
          this.currMedicare,
          this.medicare_num[0].data,
        );
        payload = {
          type: "medicare",
          number: this.medicare_num[0].data
            ? String(this.medicare_num[0].data).replace(/\s+/g, "")
            : "",
          patient_id: this.patientUUID,
        };
      } else if (
        this.dva_num &&
        this.dva_num.length &&
        this.currDVA != this.dva_num[0].data
      ) {
        console.log(
          "this is the dva match",
          this.currDVA,
          this.dva_num[0].data,
        );
        payload = {
          type: "dva",
          number: this.dva_num[0].data
            ? String(this.dva_num[0].data).replace(/\s+/g, "")
            : "",
          patient_id: this.patientUUID,
        };
      } else if (this.ihiDetails && this.ihiDetails.number) {
        console.log("using ihi details");
        payload = {
          type: "ihi",
          number: this.ihiDetails.number
            ? this.ihiDetails.number.split(" ").join("")
            : "",
          patient_id: this.patientUUID,
        };
      } else {
        if (
          this.medicare_num &&
          this.medicare_num.length &&
          this.medicare_num[0].data
        ) {
          console.log("validating against medicare, no change");
          payload = {
            type: "medicare",
            number: this.medicare_num[0].data
              ? String(this.medicare_num[0].data).replace(/\s+/g, "")
              : "",
            patient_id: this.patientUUID,
          };
        } else if (
          this.dva_num &&
          this.dva_num.length &&
          this.dva_num[0].data
        ) {
          console.log("validating against dva, no change");
          payload = {
            type: "dva",
            number: this.dva_num[0].data
              ? String(this.dva_num[0].data).replace(/\s+/g, "")
              : "",
            patient_id: this.patientUUID,
          };
        } else {
          console.log("NO NUMBER TO VALIDATE AGAINST");
        }
      }

      axios
        .post("/validate-ihi", payload, this.$store.state.header)
        .then((response) => {
          console.log("this is the response for validate IHI", response.data);
          this.validIHI(response, clicked);
        })
        .catch((err) => {
          console.log(
            "/validate-ihi failed with the following error:",
            err,
            err.response,
          );
          // CHECK IF THE RESPONSE IS RESOLVED BUT FOR A DIFFERENT IHI
          if (
            err.response &&
            err.response.data &&
            err.response.data.error &&
            err.response.data.error.includes("duplicate")
          ) {
            console.log(
              "Resolved and different IHI number returned",
              err.response.data.data,
            );
            payload = {
              type: "ihi",
              number: err.response.data.data.ihi_number,
              patient_id: this.patientUUID,
            };
            axios
              .post("/validate-ihi", payload, this.$store.state.header)
              .then((response) => {
                console.log(
                  "This is the response for the second validate IHI",
                  response.data,
                );
                this.validIHI(response, clicked);
              })
              .catch((err) => {
                this.invalidIHI(err, clicked);
              });
          }
          this.invalidIHI(err, clicked);
        });
    },
    validIHI(response, clicked) {
      this.ihiDetails = response.data.data;
      this.currMedicare = this.medicare_num[0].data;
      this.currDVA = this.dva_num[0].data;
      if (clicked) {
        axios
          .post(`/person/${this.patientUUID}/ihi`, {}, this.$store.state.header)
          .then((res) => {
            console.log("this is the response for the ihi", res.data);
            this.ihiDetails = res.data;
          })
          // A patient with no IHI gets a 400 with "No active IHI numbers for this
          // individual." - the normal case for most residents, not a failure. Without a
          // handler it surfaced as an unhandled rejection on every one of them.
          .catch((err) => {
            console.log("this is the error of the ihi call", err);
          });
      }
    },
    invalidIHI(err, clicked) {
      this.displaySuccessModal = false;
      if (!err?.response?.data?.error?.includes("unique")) {
        this.ihiDetails.number = "";
        this.ihiDetails.ihi_record_status = "";
        this.ihiDetails.ihi_status = "";
      }
      if (clicked) {
        axios
          .post(`/person/${this.patientUUID}/ihi`, {}, this.$store.state.header)
          .then((res) => {
            this.ihiDetails = res.data;
          })
          .catch((err2) => {
            console.log("this is the error of the ihi call", err2);
          });
      }
      this.errActions = err.response.data.data
        ? err.response.data.data.service_message.reason
        : "Please update information or try again later.";
      this.displaySuccessModal = true;
      this.successMessage = err.response.data.error
        ? err.response.data.error
        : err.response.data.exception
        ? "Error."
        : err.response.data;
      this.second_spec_line =
        "If this is incorrect, please check the personal information and try again.";
    },
    retrieveSelectedFacilityLocations() {
      this.loadingLocations = true;
      this.locationDirectory = "";
      console.log("this is the selected facility", this.selectedFacility);
      axios
        .post(
          `/facility/${this.selectedFacility.value}/locations`,
          {},
          this.$store.state.header,
        )
        .then((res) => {
          console.log("these are the facilitys locations", res.data);
          this.nodes = res.data;
          this.$store.dispatch("getRefreshToken");
          this.nodes = res.data;
          this.nodes.forEach((node) => {
            node.label = node.name;
            if (node.children.length) {
              this.getChildLocation(node);
            }
          });
          this.loadingLocations = false;
        })
        .catch((err) => {
          console.log("this is the locations error", err.response.data);
          this.displaySuccessModal = true;
          this.successMessage = err.response.data;
        });
    },
    getFacilities() {
      axios
        .post("/get-facilities", {}, this.$store.state.header)
        .then((res) => {
          this.facilities = res.data;
        })
        .catch((err) => {
          console.log("err issss", typeof err.response.data);
          if (
            err.response &&
            err.response.data &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
          console.log("err is", err.response.data, err.response.data);
        });
    },
    getFacilityPrescibers() {
      const endpoint =
        "/facility/" +
        this.$store.state.currentLocation.facility.uuid +
        "/prescribers";
      axios
        .post(endpoint, {}, this.$store.state.header)
        .then((res) => {
          this.facilitiesPrescribers = res.data;
          this.facilitiesPrescribers.forEach((prescriber, index) => {
            if (
              this.patient.primary_prescriber?.uuid &&
              prescriber.uuid == this.patient.primary_prescriber?.uuid
            ) {
              this.facilitiesPrescribers.splice(index, 1);
            }
          });
        })
        .catch((err) => {
          console.log("err issss", typeof err.response.data);
          if (
            err.response &&
            err.response.data &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
          console.log("err is", err.response.data, err.response.data);
        });
    },
    getPharmacies() {
      let facilityID =
        this.$store.state.currentLocation?.facility &&
        this.$store.state.currentLocation.facility.uuid
          ? this.$store.state.currentLocation.facility.uuid
          : "175f2a90-b5f8-4079-8ea0-07367b0c2db8";
      axios
        .post(
          `/facility/${facilityID}/pharmacies`,
          {},
          this.$store.state.header,
        )
        .then((res) => {
          console.log("these are the pharmacies", res.data);
          this.pharmacies = res.data;
        });
    },

    submitPharmacy() {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      axios
        .post(
          `/person/${this.patientUUID}/link-pharmacy`,
          { pharmacy_id: this.selectedPharmacy.uuid },
          this.$store.state.header,
        )
        .then((res) => {
          console.log("patient pharmacy submitted.", res);
          axios
            .post(
              `/person/${this.patientUUID}/pharmacies`,
              {},
              this.$store.state.header,
            )
            .then((res) => {
              console.log("retrieve patient pharmacies submitted.", res);
              this.first_spec_line = "Patient updated!";
              this.patient.latest_pharmacies = res.data;
            });
        });
    },

    getPrescribers() {
      let facilityID =
        this.$store.state.currentLocation?.facility &&
        this.$store.state.currentLocation.facility.uuid
          ? this.$store.state.currentLocation.facility.uuid
          : "175f2a90-b5f8-4079-8ea0-07367b0c2db8";
      this.loadingPrescribers = true;
      axios
        .post(
          `/facility/${facilityID}/prescribers`,
          {},
          this.$store.state.header,
        )
        .then((res) => {
          console.log("these are the prescribers", res.data);
          this.prescribers = [];
          res.data.forEach((item) => {
            if (item.name && item.name != " ") {
              this.prescribers.push(item);
            }
          });
          this.prescribers = this.prescribers.filter(
            (v, i, a) => a.indexOf(v) === i,
          );
          // remove primary if there is one
          if (this.patient.primary_prescriber != null) {
            console.log("1");
            this.additionalPrescribers = this.prescribers.filter(
              (prescriber) =>
                this.patient.primary_prescriber.uuid != prescriber.uuid,
            );
          } else {
            console.log("2");
            this.additionalPrescribers = this.prescribers;
          }
        })
        .catch((err) => {
          console.error("Failed to load prescribers", err);
        })
        .finally(() => {
          this.loadingPrescribers = false;
        });
    },
    submitPrescriber(additionalPrescriber) {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      axios
        .post(
          `/person/${this.patientUUID}/link-prescriber`,
          {
            prescriber_id: additionalPrescriber
              ? this.additional_prescriber.uuid
              : this.selectedPrescriber.uuid,
            primary: additionalPrescriber ? false : true,
          },
          this.$store.state.header,
        )
        .then((res) => {
          console.log("patient prescriber submitted.", res);
          this.first_spec_line = "Patient updated!";
          if (!additionalPrescriber) {
            // update primary prescriber locally
            this.patient.primary_prescriber = this.selectedPrescriber;
            // update additonal prescribers
            this.additionalPrescribers = this.prescribers.filter(
              (prescriber) =>
                this.patient.primary_prescriber.uuid != prescriber.uuid,
            );
          } else {
            console.log("adding linked prescriber", this.additional_prescriber);
            this.facilitiesPrescribers.push({
              personal_information: {
                first_name: this.additional_prescriber.name.split(" ")[0],
                last_name: this.additional_prescriber.name.split(" ")[1],
              },
              uuid: this.additional_prescriber.uuid,
            });
            this.additional_prescriber = "";
          }
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
          console.log("err is", err.response.data, err.response.data);
          this.first_spec_line = "Error: " + err.response.data;
        });
    },
    unlinkPrescriber(gp) {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      axios
        .post(
          `/person/${this.patientUUID}/unlink-prescriber`,
          { prescriber_id: gp.uuid },
          this.$store.state.header,
        )
        .then((res) => {
          console.log("patient prescriber submitted.", res);
          this.first_spec_line = "Patient updated!";
          this.facilitiesPrescribers.forEach((prescriber, index) => {
            if (prescriber.uuid == gp.uuid) {
              console.log(
                "matched unlinked prescriber",
                this.facilitiesPrescribers,
                prescriber,
                index,
              );
              // this.patient.prescribers.splice(index,1);
              this.facilitiesPrescribers.splice(index, 1);
            }
          });
          // update fe data to reflect changes
          this.patient.prescribers = this.patient.prescribers.filter(
            (prescriber) => prescriber.uuid != gp.uuid,
          );
        })
        .catch((err) => {
          this.first_spec_line = "Error: " + err.response;
        });
    },
    unlinkPharmacy(uuid) {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      axios
        .post(
          `/person/${this.patientUUID}/unlink-pharmacy`,
          { satellite_id: uuid },
          this.$store.state.header,
        )
        .then((res) => {
          console.log("unlink pharmacy submitted.", res);
          this.first_spec_line = "Patient updated!";
          this.patient.latest_pharmacies =
            this.patient.latest_pharmacies.filter(
              (pharmacy) => pharmacy.satellite_uuid !== uuid,
            );
          this.selectedPharmacy = this.patient.latest_pharmacies
            ? this.patient.latest_pharmacies[0]
            : "";
        })
        .catch((err) => {
          this.first_spec_line = "Error: " + err.response;
        });
    },
    linkPrescriber(gp) {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      this.loading = true;
      axios
        .post(
          `/person/${this.patientUUID}/link-prescriber`,
          { prescriber_id: gp.uuid, primary: false },
          this.$store.state.header,
        )
        .then((res) => {
          console.log("patient additonal prescriber submitted.", res);
          this.loading = false;
          this.first_spec_line = "Patient updated!";
          // update fe data to reflect changes
          this.patient.prescribers.push(gp);
        })
        .catch((err) => {
          this.loading = false;
          this.errActions =
            err.response && err.response.data
              ? err.response.data
              : "Error linking prescriber";
          console.log("Error linking prescriber", err);
        });
    },
    // UPLOAD IMAGE
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    nextFormPage() {
      if (this.selectedNavigation == "personal_information") {
        console.log("hitting the if, personal_information");
        this.selectedNavigation = this.navigationItems[3].link;
      } else {
        switch (this.selectedNavigation) {
          case "prescriber_details":
            this.selectedNavigation = this.navigationItems[4].link;
            break;
          case "allergies":
            this.selectedNavigation = "considerations";
            break;
          case "considerations":
            this.selectedNavigation = this.navigationItems[6].link;
            break;
          case "vaccinations":
            this.selectedNavigation = this.navigationItems[7].link;
            break;
          case "complex":
            break;
        }
      }
    },
    // FORM SUBMIT PROCESS

    // REGISTER PATIENT
    editPersonalPatientInfo() {
      this.checkSimilarNames().then((matches) => {
        if (matches && matches.length > 0) {
          this.similarNameWarningMessage =
            this.buildSimilarNameWarningMessage(matches);
          this.displaySimilarNameModal = true;
          return;
        }

        this.performPersonalInfoSave();
      });
    },
    saveClinicalDetails() {
      this.loading = true;
      this.displaySuccessModal = true;
      this.errActions = "";

      const patientId = this.$route.params.id;
      const requests = [];

      if (
        this.clinicalDetails.height_cm !== "" &&
        this.clinicalDetails.height_cm !== null &&
        this.clinicalDetails.height_cm !== undefined
      ) {
        requests.push(
          axios.post(
            "/create-reading",
            {
              patient_id: patientId,
              unit: "cm",
              type: "Height",
              value: Number(this.clinicalDetails.height_cm),
            },
            this.$store.state.header,
          ),
        );
      }

      if (
        this.clinicalDetails.weight_kg !== "" &&
        this.clinicalDetails.weight_kg !== null &&
        this.clinicalDetails.weight_kg !== undefined
      ) {
        requests.push(
          axios.post(
            "/create-reading",
            {
              patient_id: patientId,
              unit: "kg",
              type: "Weight",
              value: Number(this.clinicalDetails.weight_kg),
            },
            this.$store.state.header,
          ),
        );
      }

      Promise.all(requests)
        .then(() => {
          this.loading = false;
          this.first_spec_line = "Successfully updated!";
        })
        .catch((err) => {
          this.loading = false;
          console.log("this is the err", err);
          this.errActions =
            err.response && err.response.data
              ? err.response.data
              : "Error saving clinical details";
        });
    },
    performPersonalInfoSave() {
      this.loading = true;
      this.displaySuccessModal = true;
      this.errActions = "";

      const payload = { ...this.personalInformation };

      if (payload.dob && payload.dob.includes("-")) {
        const parts = payload.dob.split("-");
        if (parts.length === 3) {
          payload.dob = `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
      }

      axios
        .post(
          "/person/" + this.$route.params.id + "/edit",
          payload,
          this.$store.state.header,
        )
        .then((res) => {
          console.log("patient registered.", res);
          this.loading = false;
          this.first_spec_line = "Successfully updated!";
          this.editEntitlementNumbers();
          this.personalInformation.dob = `${
            res.data.personal_information.dob.split("/")[2]
          }-${res.data.personal_information.dob.split("/")[1]}-${
            res.data.personal_information.dob.split("/")[0]
          }`;
          // this.personalInformation.dob = `${this.patient.personal_information.dob.split('/')[2]}-${this.patient.personal_information.dob.split('/')[1]}-${this.patient.personal_information.dob.split('/')[0]}`;
        })
        .catch((err) => {
          this.loading = false;
          console.log("this is the err", err);
          this.errActions =
            err.response && err.response.data
              ? err.response.data
              : "Error updating personal information";
          if (
            err.response &&
            err.response.data &&
            typeof err.response.data === "string" &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
        });
    },
    close(value) {
      if (value) {
        this.displaySuccessModal = false;
        this.displayIHIHistoryModal = false;
        this.displayIHIConflictModal = false;
        this.first_spec_line = "";
        this.second_spec_line = "";
        this.errActions = "";
        this.successMessage = "";
      }
    },
    ValidateInput(validation) {
      this.validationError = false;
      this.validationErrorMessage = "";
      switch (validation) {
        case "editNextOfKin":
          //check name if alpha nummeric
          //check phone number between 8 and 11 digits
          //check email if valid format (not deliverability)
          this.validationErrorMessage =
            !this.ValidateRegex(this.kin.first_name, /^[0-9a-zA-Z _-]+$/) &&
            this.validationErrorMessage == ""
              ? "Please make sure the first name is filled in and does not contain any special characters."
              : this.validationErrorMessage;
          this.validationErrorMessage =
            !this.ValidateRegex(this.kin.last_name, /^[0-9a-zA-Z _-]+$/) &&
            this.validationErrorMessage == ""
              ? "Please make sure the last name is filled in and does not contain any special characters."
              : this.validationErrorMessage;
          this.validationErrorMessage =
            !this.ValidateRegex(this.kin.phone, /^[0-9]{8,11}$/) &&
            this.validationErrorMessage == ""
              ? "Please make sure the phone number only contains digits and is a valid number (8-11 digits)."
              : this.validationErrorMessage;
          this.validationErrorMessage =
            !this.ValidateRegex(
              this.kin.email,
              /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
            ) && this.validationErrorMessage == ""
              ? "Please make sure the email address is valid."
              : this.validationErrorMessage;
          return this.validationErrorMessage == "" ? true : false;
      }
      return true;
    },
    // check if input is valid - regex
    ValidateRegex(input, regex) {
      if (!input) {
        return false;
      }
      return regex.test(input);
    },
    editNextOfKin() {
      // validate the input based on next of kin validation rules
      if (!this.ValidateInput("editNextOfKin")) {
        this.validationError = true;
        return false;
      }
      // resetting the modal message
      this.first_spec_line = "";
      this.errActions = "";

      this.loading = true;
      this.displaySuccessModal = true;
      console.log("this is the kin", this.kin);
      axios
        .post(
          `/patient/${this.patientUUID}/kin${
            this.kin.uuid ? "/" + this.kin.uuid : ""
          }`,
          this.kin,
          this.$store.state.header,
        )
        .then((res) => {
          console.log("kin has been updated", res.data);
          this.loading = false;
          this.errActions = "";
          this.first_spec_line = "Successfully updated!";
        })
        .catch((err) => {
          // adding error handling
          this.loading = false;
          this.errActions = err.response.data;

          console.log("this is the err", err);
          if (
            err.response &&
            err.response.data &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
        });
    },
    editEntitlementNumbers() {
      if (this.medicareIndex !== -1 && !this.validMedicareExpiry) {
        this.validationError = true;
        this.validationErrorMessage =
          "Please make sure the Medicare Expiry date is valid (in the future).";
        return;
      }
      if (this.dvaIndex !== -1 && !this.validDVAExpiry) {
        this.validationError = true;
        this.validationErrorMessage =
          "Please make sure the DVA Expiry date is valid (in the future).";
        return;
      }
      if (
        this.dvaIndex !== -1 &&
        this.regulatory_numbers[this.dvaIndex].expiry &&
        !this.regulatory_numbers[this.dvaIndex].data
      ) {
        this.validationError = true;
        this.validationErrorMessage =
          "Please enter a DVA Number to save the DVA Expiry date.";
        return;
      }
      this.validationError = false;
      this.validationErrorMessage = "";
      this.first_spec_line = "";
      this.loading = true;
      this.displaySuccessModal = true;
      let payload = [];
      this.regulatory_numbers.forEach((num) => {
        console.log("reg num: ", num);
        if (num.uuid) {
          axios
            .post(
              `/person/${this.patientUUID}/remove-regulatory/${num.uuid}`,
              {},
              this.$store.state.header,
            )
            .then((res) => {
              console.log(res);
            });
        }
        if (num.data) {
          let submitData =
            typeof num.data === "string"
              ? num.data.replace(/\s+/g, "")
              : String(num.data);
          let submitType = num.regulatory_type;
          if (num.expiry) {
            num.expiry = this.formatExpiryForSubmit(num.expiry);
          }
          if (["DVA Gold", "DVA White", "DVA Orange"].includes(submitType)) {
            submitData = submitData + "|" + submitType;
            submitType = "DVA Number";
          }
          payload.push({
            data: submitData,
            regulatory_type: submitType,
            expiry: num.expiry,
          });
        }
        delete num.uuid;
        delete num.number;
      });
      if (payload.length) {
        axios
          .post(
            `/person/${this.patientUUID}/regulatory`,
            { regulatory_numbers: payload },
            this.$store.state.header,
          )
          .then((res) => {
            console.log("updated ent numbers", res);
            this.loading = false;
            this.first_spec_line = "Successfully updated!";
            let responseData = res.data.map((resNum) => {
              if (
                resNum.regulatory_type === "DVA Number" &&
                resNum.data &&
                resNum.data.includes("|")
              ) {
                let parts = resNum.data.split("|");
                resNum.data = parts[0];
                resNum.regulatory_type = parts[1];
              }
              return resNum;
            });
            this.regulatory_numbers.forEach((number) => {
              responseData.forEach((resNum) => {
                if (resNum.regulatory_type == number.regulatory_type) {
                  number = resNum;
                  number.uuid = resNum.uuid;
                  console.log(
                    "this is the regulatory number uuid",
                    resNum.uuid,
                    number,
                  );
                }
              });
            });
            setTimeout(() => {
              console.log(
                "this is the reg number after 2 secs",
                this.regulatory_numbers,
              );
            }, 2000);
            axios
              .post(
                `/person/${this.patientUUID}/ihi`,
                {},
                this.$store.state.header,
              )
              .then((res) => {
                this.ihiDetails = res.data;
                if (res.data.conflicted) {
                  this.displayIHIConflictModal = true;
                }
                this.validateIHINumber(true);
              })
              .catch((ihiErr) => {
                console.log("this is the error of the ihi call", ihiErr);
              });
          })
          .catch((err) => {
            this.loading = false;
            this.errActions =
              err.response && err.response.data
                ? err.response.data
                : "Error updating entitlement numbers";
            console.log("this is the err", err);
            if (
              err.response &&
              err.response.data &&
              typeof err.response.data === "string" &&
              err.response.data.split(" ").includes("expired")
            ) {
              console.log("yes, it does include expired");
              this.$router.push("/login");
            }
          });
      }
    },
    // SUBMIT IMAGE
    submitImage() {
      if (this.previewImage) {
        axios
          .post(
            `/aws/patient/${this.patientUUID}/image`,
            {
              image: this.previewImage,
              item: ["profile", "thumbnail"],
            },
            this.$store.state.header,
          )
          .then((res) => {
            console.log("uploaded patient image", res);
            this.displaySuccessModal = true;
            this.first_spec_line = "Successfully uploaded image";
            this.$store.dispatch("getRefreshToken");
          })
          .catch((err) => {
            this.displaySuccessModal = true;
            this.second_spec_line = "";
            this.first_spec_line =
              err.response && err.response.data ? err.response.data : err;
          });
      } else {
        console.log("No image has been uploaded");
      }
    },
    // CONFIRM FACILITY LOCATION
    // confirmFacilityLocation(){
    //     if(this.facility_location.room_uuid){
    //         axios.post(`/patient/${this.patientUUID}/move-location/${this.facility_location.room_uuid}`, {}, this.$store.state.header).then(res=>{
    //             console.log('facility location submitted.', res)
    //         })
    //     } else{
    //         console.log('no facility location confirmed.')
    //     }
    // },
    // CONFIRM FACILITY LOCATION
    confirmFacilityLocation() {
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      this.successMessage = "";
      if (Object.keys(this.selectedNodeKey)[0]) {
        axios
          .post(
            `/person/${this.patientUUID}/location`,
            {
              status: "resident",
              location: Object.keys(this.selectedNodeKey)[0],
            },
            this.$store.state.header,
          )
          .then((res) => {
            this.completedActions += 1;
            console.log("facility location submitted.", res);
            this.first_spec_line = "Patient updated!";
          })
          .catch((err) => {
            this.completedActions += 1;
            // Keeping tab on error count for possibly more detailed error management
            this.errActionsCount += 1;
            this.errActions +=
              " Error assigning " + this.$resident() + " to location.";
            console.log(
              "this is the link resident error",
              err,
              err.response.data,
            );
            this.first_spec_line = "Error: " + err.response.data;
          });
      } else {
        console.log("no facility location confirmed.");
      }
    },
    // REGULATORY INFO
    submitRegulatoryInfo() {
      let regulatory_numbers = [];
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      for (let key in this.regulatory_numbers) {
        console.log("this is the key", key);
        if (this.regulatory_numbers[key].number) {
          regulatory_numbers.push({
            number: this.regulatory_numbers[key].number,
            regulator_type: this.regulatory_numbers[key].regulator_type,
            date: this.regulatory_numbers[key].expiry
              ? this.regulatory_numbers[key].expiry
              : "",
          });
        }
      }
      if (this.regulatory_numbers.length) {
        this.loading = true;
        axios
          .post(
            `/patient/${this.patientUUID}/regulatory`,
            regulatory_numbers,
            this.$store.state.header,
          )
          .then((res) => {
            console.log("regulatory information submitted.", res);
            this.loading = false;
            this.first_spec_line = "Patient updated!";
          })
          .catch((err) => {
            this.loading = false;
            this.errActions =
              err.response && err.response.data
                ? err.response.data
                : "Error updating regulatory info";
            console.log("Error updating regulatory info", err);
          });
      } else {
        console.log("no regulatory numbers filled in or submitted.");
      }
    },
    // PATIENT ADDRESS
    setPatientAddress() {
      this.$store.dispatch("getRefreshToken");
      // Check if address actually changed or is new
      const isChanged =
        this.address.street_address &&
        (!this.patient.address ||
          this.address.street_address !== this.patient.address.street_address ||
          this.address.suburb !== this.patient.address.suburb ||
          this.address.postcode !== this.patient.address.postcode);

      if (isChanged) {
        this.displaySuccessModal = true;
        this.first_spec_line = "Updating patient...";
        this.loading = true;
        return axios
          .post(
            `/person/${this.patientUUID}/address`,
            this.address,
            this.$store.state.header,
          )
          .then((res) => {
            console.log("patient address submitted.", res);
            this.patient.address = { ...this.address };
            this.first_spec_line = "Patient address updated!";
            return res;
          })
          .catch((err) => {
            this.loading = false;
            this.errActions =
              err.response && err.response.data
                ? err.response.data.message || err.response.data
                : "Error updating address";
            console.log("Error updating address", err);
            if (
              err.response &&
              err.response.data &&
              typeof err.response.data === "string" &&
              err.response.data.split(" ").includes("expired")
            ) {
              this.$router.push("/login");
            }
            throw err;
          });
      } else {
        console.log(
          "no address has been added or submitted (or it has not changed)",
        );
        return null;
      }
    },
    editContactMethods() {
      this.$store.dispatch("getRefreshToken");
      const promises = [];

      let telephoneNumberFormatted = this.untitled.phone || "";
      telephoneNumberFormatted = telephoneNumberFormatted.replace(/ /g, "");

      if (
        telephoneNumberFormatted &&
        !telephoneNumberFormatted.startsWith("+61")
      ) {
        telephoneNumberFormatted = "+61" + telephoneNumberFormatted;
      }

      // Phone number update logic
      const phoneChanged =
        telephoneNumberFormatted !== this.initialContact.phone;
      if (phoneChanged && telephoneNumberFormatted) {
        if (this.untitled.phone_uuid) {
          promises.push(
            axios
              .post(
                `/person/${this.patientUUID}/contact-method/${this.untitled.phone_uuid}/edit`,
                { data: telephoneNumberFormatted },
                this.$store.state.header,
              )
              .then((res) => {
                console.log("phone has been updated", res.data);
                this.initialContact.phone = telephoneNumberFormatted;
                this.first_spec_line = "Patient phone number updated!";
                return res;
              }),
          );
        } else {
          let phone = {
            name: "phone",
            data: telephoneNumberFormatted,
            type: "phone",
          };
          promises.push(
            axios
              .post(
                `/person/${this.patientUUID}/contact-method`,
                { contact_methods: [phone] },
                this.$store.state.header,
              )
              .then((res) => {
                console.log("contact method has been saved (new phone)", res);
                this.initialContact.phone = telephoneNumberFormatted;
                if (res.data && res.data[0])
                  this.untitled.phone_uuid = res.data[0].uuid;
                this.first_spec_line = "Patient phone number updated!";
                return res;
              }),
          );
        }
      }

      // Email update logic
      const emailFormatted = this.untitled.email || "";
      const emailChanged = emailFormatted !== this.initialContact.email;
      if (emailChanged && emailFormatted) {
        if (this.untitled.email_uuid) {
          promises.push(
            axios
              .post(
                `/person/${this.patientUUID}/contact-method/${this.untitled.email_uuid}/edit`,
                { data: emailFormatted },
                this.$store.state.header,
              )
              .then((res) => {
                console.log("email has been updated", res.data);
                this.initialContact.email = emailFormatted;
                this.first_spec_line = "Patient email updated!";
                return res;
              }),
          );
        } else {
          let email = {
            name: "Email",
            data: emailFormatted,
            type: "email",
          };
          promises.push(
            axios
              .post(
                `/person/${this.patientUUID}/contact-method`,
                { contact_methods: [email] },
                this.$store.state.header,
              )
              .then((res) => {
                console.log("contact method has been saved (new email)", res);
                this.initialContact.email = emailFormatted;
                if (res.data && res.data[0])
                  this.untitled.email_uuid = res.data[0].uuid;
                this.first_spec_line = "Patient email updated!";
                return res;
              }),
          );
        }
      }

      if (promises.length > 0) {
        this.displaySuccessModal = true;
        this.loading = true;
        this.errActions = "";
      }

      return promises;
    },
    async editContactDetails() {
      // Validation: Address is mandatory
      const hasExistingAddress =
        this.patient.address && this.patient.address.street_address;
      const hasNewAddress = this.address && this.address.street_address;

      if (!this.isSimplified && !hasExistingAddress && !hasNewAddress) {
        this.displaySuccessModal = true;
        this.first_spec_line = "Address is mandatory. Please enter an address.";
        this.errActions = "Address is mandatory.";
        this.loading = false;

        // Focus the address input
        const addressInput = document.getElementById("contactmap");
        if (addressInput) {
          addressInput.focus();
        }
        return;
      }

      this.errActions = "";
      this.first_spec_line = "Checking for changes...";

      const addressPromise = this.setPatientAddress();
      const methodPromises = this.editContactMethods();

      const allPromises = [];
      if (addressPromise) allPromises.push(addressPromise);
      if (methodPromises && methodPromises.length)
        allPromises.push(...methodPromises);

      if (allPromises.length === 0) {
        this.displaySuccessModal = true;
        this.first_spec_line = "No changes detected.";
        this.loading = false;
        return;
      }

      try {
        await Promise.all(allPromises);
        this.loading = false;
        this.first_spec_line = "Successfully updated contact details!";
      } catch (err) {
        this.loading = false;
        console.log("Error in editContactDetails", err);
        // Individual methods already set errActions
      }
    },
    // CREATE KIN
    createKin() {
      if (this.kin.first_name) {
        let names = this.kin.split(" ");
        this.kin.first_name = names.shift();
        this.kin.last_name = names.join(" ");
        axios
          .post(
            `/patient/${this.patientUUID}/kin`,
            this.kin,
            this.$store.state.header,
          )
          .then((res) => {
            console.log("patient kin submitted.", res);
            this.errActions = "";
            this.first_spec_line = "Successfully saved kin.";
            this.displaySuccessModal = true;
          });
      } else {
        console.log(
          "first name of kin not entered, so submission not made for kin",
        );
      }
    },
    // ADD PHONE AND EMAIL CONTACT METHODS
    addContactMethods() {
      this.$store.dispatch("getRefreshToken");
      let contactMethods = [];
      if (this.untitled.phone) {
        contactMethods.push({
          name: "Phone",
          data: this.untitled.phone,
          type: "phone",
        });
      }
      if (this.untitled.email) {
        contactMethods.push({
          name: "Email",
          data: this.untitled.email,
          type: "email",
        });
      }
      if (this.contactMethods.length) {
        this.displaySuccessModal = true;
        this.first_spec_line = "Updating patient...";
        axios
          .post(
            `/patient/${this.patientUUID}/contact-method`,
            { contact_methods: contactMethods },
            this.$store.state.header,
          )
          .then((res) => {
            console.log("patient kin submitted.", res);
            this.first_spec_line = "Patient updated!";
          });
      } else {
        console.log(
          "no contact methods were entered, therefore not submitted.",
        );
      }
    },
    // A DrugSearchInput row only sets item.drug when the user actually picks a dropdown
    // option (see DrugSearchInput.vue onChange/onInput) - typing a name and clicking/tabbing
    // away leaves item.drug null while item.drug_name keeps the typed text. Without this
    // check, submitADR's `item.custom || item.drug` filter would silently drop that row from
    // the payload while still reporting success, losing the allergy record.
    isUnresolvedAdrDrugName(item) {
      return (
        item.reaction_type !== "nkda" &&
        !item.custom &&
        !item.drug &&
        !!(item.drug_name || "").trim()
      );
    },
    // A comparable fingerprint of the fields that actually get persisted for an ADR row.
    // Used to work out which existing rows were genuinely edited since load (see submitADR).
    serializeAdrForCompare(item) {
      return JSON.stringify({
        custom: item.custom || "",
        drug: item.drug || null,
        drug_name: item.drug_name || "",
        description: item.description || "",
        reaction_type: item.reaction_type || "",
        severity: item.severity || "",
        status: item.status || "",
        date: item.date || "",
      });
    },
    // SUBMIT ADR ARRAY
    //
    // Kraken's /patient/:uuid/adr endpoint always inserts brand-new rows - it has no
    // update-by-uuid path (confirmed against the kraken source: addADRs() unconditionally
    // does `new AdverseDrugReaction(['uuid' => Str::uuid(), ...])` for every submitted item
    // and never looks up an existing row). So editing an existing ADR's fields genuinely does
    // require retiring the old row and creating a replacement - there's no way around that
    // without a kraken change. But there's no reason to do that to *every* row on every save:
    // - Rows removed via the trash icon are already deleted individually and immediately by
    //   removeADR() - they're simply gone from `untitled.adr` by the time we get here.
    // - Rows that are unchanged since load don't need to be touched at all.
    // Only rows that are new or have actually changed get recreated, and - critically - the
    // old copies of changed rows are only deleted AFTER the replacement is confirmed saved.
    // If the create call fails, nothing is deleted, so a failed save can never leave the
    // patient with fewer recorded allergies than before (previously: any failure on the
    // recreate step, after every row had already been deleted, wiped the patient's allergies
    // server-side while the UI still showed the old list).
    submitADR() {
      this.$store.dispatch("getRefreshToken");
      this.adrErrorMessage = "";

      const unresolvedCount = this.untitled.adr.filter((item) =>
        this.isUnresolvedAdrDrugName(item),
      ).length;
      if (unresolvedCount) {
        this.adrErrorMessage =
          unresolvedCount === 1
            ? 'One ADR entry has a drug name typed but not selected from the list (highlighted below). Please choose an option from the dropdown, or clear the Drug Name field and use "Custom / Other Substance" instead before saving.'
            : `${unresolvedCount} ADR entries have a drug name typed but not selected from the list (highlighted below). Please choose an option from the dropdown for each, or clear the Drug Name field and use "Custom / Other Substance" instead before saving.`;
        return;
      }

      // NKDA and real ADR entries are contradictory - see toggleNkda's guard for turning NKDA
      // on while entries exist. This closes the other direction: NKDA could otherwise still be
      // switched on first (with the list empty) and a real entry added and saved afterwards.
      if (this.nkda && this.untitled.adr.some((item) => item.custom || item.drug)) {
        this.adrErrorMessage =
          "This resident is currently marked as No Known Drug Allergies. Uncheck NKDA above before saving real allergy/ADR entries.";
        return;
      }

      // Rows that need *something* done: brand new rows, or existing rows whose fields no
      // longer match what was loaded/last saved.
      const rowsToSave = this.untitled.adr.filter((item) => {
        if (!item.uuid) return true;
        return (
          this.serializeAdrForCompare(item) !== this.adrPristineSnapshot[item.uuid]
        );
      });

      if (!rowsToSave.length) {
        this.displaySuccessModal = true;
        this.loading = false;
        this.first_spec_line = "No changes to save.";
        return;
      }

      // Existing rows being replaced/retired - captured now, before anything is mutated, so
      // we know exactly what to clean up once (and only once) the replacement is safely saved.
      const uuidsToRetireAfterSave = rowsToSave
        .filter((item) => item.uuid)
        .map((item) => item.uuid);

      // Of the rows needing action, only genuinely-populated ones (a custom substance name or
      // a resolved drug) need a new row created - an existing row that's been edited down to
      // nothing in both fields is being removed, not recreated, matching the pre-existing
      // convention that a blank row/entry is simply not persisted.
      const rowsToCreate = rowsToSave.filter((item) => item.custom || item.drug);

      this.displaySuccessModal = true;
      this.loading = true;

      const retireStaleRows = () => {
        const retirePromises = uuidsToRetireAfterSave.map((uuid) =>
          axios
            .post(
              `/patient/${this.patientUUID}/adr/${uuid}/delete`,
              {},
              this.$store.state.header,
            )
            .catch((err) => {
              // Best-effort: the correct/current data is already safely saved above (or
              // there was nothing to recreate), so a failure here just leaves a harmless,
              // superseded duplicate rather than any data loss.
              console.log("Error retiring superseded adr entry", uuid, err);
            }),
        );
        return Promise.all(retirePromises);
      };

      const finish = () => {
        this.loading = false;
        this.first_spec_line = "Successfully updated ADR list!";
      };

      const fail = (err) => {
        console.log("Error submitting adr", err);
        this.loading = false;
        // Nothing was deleted - the patient's previously-saved allergies are untouched.
        this.adrErrorMessage =
          "Failed to save ADR changes - no changes were applied. " +
          (err.response?.data?.message ||
            err.response?.data ||
            "Please try again.");
        if (
          err.response &&
          err.response.data &&
          typeof err.response.data === "string" &&
          err.response.data.split(" ").includes("expired")
        ) {
          this.$router.push("/login");
        }
      };

      if (!rowsToCreate.length) {
        // Every changed row was an existing entry blanked out to nothing - nothing to create,
        // just retire the superseded rows.
        retireStaleRows().then(finish);
        return;
      }

      const adrPayload = rowsToCreate.map((item) => {
        let citem = { ...item };
        if (citem.date) {
          citem.date = new Date(citem.date).toLocaleDateString("en-AU");
        }
        delete citem.uuid; // kraken always assigns a fresh uuid; a stale local one is misleading
        return citem;
      });

      axios
        .post(
          `/patient/${this.patientUUID}/adr`,
          { adr: adrPayload },
          this.$store.state.header,
        )
        .then((res) => {
          const created = (res.data && res.data["0"]) || [];
          // Kraken preserves submission order in its response (confirmed against the kraken
          // source - addADRs() appends to $adrArray in the same order it iterates the
          // submitted `adr` list, with no filtering/reordering), so matching by index is safe
          // and unambiguous here.
          rowsToCreate.forEach((item, i) => {
            const createdItem = created[i];
            if (createdItem && createdItem.uuid) {
              item.uuid = createdItem.uuid;
              this.adrPristineSnapshot[item.uuid] = this.serializeAdrForCompare(item);
            }
          });

          retireStaleRows().then(finish);
        })
        .catch(fail);
    },
    // NKDA (No Known Drug Allergies) is recorded as a regular Adr entry
    // (reaction_type === "nkda") rather than a separate flag, so it shares the
    // ADR create/delete endpoints. Nothing actually enforces "superseded by adding a real
    // ADR" server-side or elsewhere in this form, so without this check a resident could be
    // flagged NKDA while also having real allergy entries recorded - a contradictory state
    // that other views (banner/summary/PDF) each have to work around inconsistently. Block
    // turning NKDA on while the visible ADR list still has real (non-blank) entries; turning
    // it off is always allowed.
    toggleNkda() {
      this.nkdaErrorMessage = "";
      if (this.nkda) {
        const hasRecordedAdrEntries = this.untitled.adr.some(
          (item) => item.custom || item.drug,
        );
        if (hasRecordedAdrEntries) {
          this.nkda = false;
          this.nkdaErrorMessage =
            "This resident has recorded allergy/ADR entries below. Remove them (or save the list with them cleared) before marking as No Known Drug Allergies.";
          return;
        }
        axios
          .post(
            `/patient/${this.patientUUID}/adr`,
            { adr: [{ reaction_type: "nkda" }] },
            this.$store.state.header,
          )
          .then((res) => {
            const created = res.data && res.data["0"] && res.data["0"][0];
            this.nkdaUuid = created ? created.uuid : null;
            this.first_spec_line = "Marked as NKDA.";
          })
          .catch((err) => {
            this.nkda = false;
            this.nkdaErrorMessage =
              err.response?.data || "Failed to update NKDA status.";
          });
      } else {
        if (!this.nkdaUuid) {
          this.first_spec_line = "NKDA cleared.";
          return;
        }
        axios
          .post(
            `/patient/${this.patientUUID}/adr/${this.nkdaUuid}/delete`,
            {},
            this.$store.state.header,
          )
          .then(() => {
            this.nkdaUuid = null;
            this.first_spec_line = "NKDA cleared.";
          })
          .catch((err) => {
            this.nkda = true;
            this.nkdaErrorMessage =
              err.response?.data || "Failed to update NKDA status.";
          });
      }
    },
    // SUBMIT SPECIAL CONSIDERATIONS
    submitSpecCons() {
      this.$store.dispatch("getRefreshToken");
      this.displaySuccessModal = true;
      this.first_spec_line = "Updating patient...";
      let specCons = {
        special_considerations: this.untitled.special_considerations,
        comments: this.untitled.special_considerations_notes,
      };
      axios
        .post(
          `/patient/${this.patientUUID}/special-considerations`,
          specCons,
          this.$store.state.header,
        )
        .then((res) => {
          console.log("spec cons submitted.", res);
          this.loading = false;
          this.first_spec_line = "Patient updated!";
        })
        .catch((err) => {
          this.loading = false;
          this.errActions =
            err.response && err.response.data
              ? err.response.data
              : "Error updating special considerations";
          console.log("Error updating special considerations", err);
        });
    },
    // SUBMIT VAX
    submitVx() {
      if (this.untitled.vaccinations[0].vaccine != "") {
        axios
          .post(
            `/patient/${this.patientUUID}/vaccinations`,
            this.untitled.vaccinations,
            this.$store.state.header,
          )
          .then((res) => {
            console.log("vaccinations submitted.", res);
          });
      } else {
        console.log("no vaccinations recorded");
      }
    },
    // SUBMIT WEIGHTS
    submitWeights() {
      if (this.untitled.weights[0].weight != "") {
        axios
          .post(
            `/patient/${this.patientUUID}/weights`,
            this.untitled.weights,
            this.$store.state.header,
          )
          .then((res) => {
            console.log("weights submitted.", res);
          });
      } else {
        console.log("no weights recorded");
      }
    },
    submitForm() {
      // this.patientRegistration();
      this.submitImage();
      this.editRegulatoryInfo();
      this.setPatientAddress();
      this.addContactMethods();
      this.submitPrescribers();
      this.submitPharmacy();
      this.submitADR();
      this.submitSpecCons();
      this.submitVx();
      this.submitWeights();
    },
    getLocations() {
      let facilityID =
        this.$store.state.currentLocation?.facility &&
        this.$store.state.currentLocation.facility.uuid
          ? this.$store.state.currentLocation.facility.uuid
          : "175f2a90-b5f8-4079-8ea0-07367b0c2db8";
      axios
        .post(`/facility/${facilityID}/locations`, {}, this.$store.state.header)
        .then((res) => {
          console.log("this is the facility location", res);
          this.$store.dispatch("getRefreshToken");
          this.nodes = res.data;
          this.nodes.forEach((node) => {
            node.label = node.name;
            if (node.children.length) {
              this.getChildLocation(node);
            }
          });
        })
        .catch((err) => {
          console.log("this is the locations error", err.response.data);
          this.displaySuccessModal = true;
          this.successMessage = err.response.data;
        });
    },
    getChildLocation(location) {
      console.log("GET CHILD LOCATION LOOPING", location);
      location.label = location.name;
      if (location.children.length) {
        location.children.forEach((child) => {
          this.getChildLocation(child);
        });
      }
    },
    addNewADR() {
      let newEntry = {
        custom: "",
        drug: null,
        drug_name: "",
        description: "",
        reaction_type: "",
        severity: "",
        status: "Active",
        date: "",
      };
      this.untitled.adr.unshift(newEntry);
    },
    removeADR(index) {
      const item = this.untitled.adr[index];
      if (!item.uuid) {
        // Never persisted - just drop it locally.
        this.untitled.adr.splice(index, 1);
        return;
      }

      // This is now the only place an existing ADR gets deleted (submitADR only recreates
      // rows that changed - see its comment), so a silently-ignored failure here would leave
      // the row deleted in the UI but still present server-side, reappearing next time the
      // patient is reloaded. Wait for the delete to succeed before removing it from the list,
      // and surface a loud error (leaving the row in place) if it fails.
      const uuid = item.uuid;
      axios
        .post(
          `/patient/${this.patientUUID}/adr/${uuid}/delete`,
          {},
          this.$store.state.header,
        )
        .then(() => {
          delete this.adrPristineSnapshot[uuid];
          const currentIndex = this.untitled.adr.indexOf(item);
          if (currentIndex !== -1) {
            this.untitled.adr.splice(currentIndex, 1);
          }
        })
        .catch((err) => {
          console.log("Error deleting adr entry", uuid, err);
          this.adrErrorMessage =
            "Failed to remove this ADR entry. Please try again.";
        });
    },
    addNewVaccine() {
      let newVaccine = {
        vaccine: "",
        date: "",
      };
      this.untitled.vaccinations.unshift(newVaccine);
    },
    removeVaccine(index) {
      this.untitled.vaccinations.splice(index, 1);
    },
    addNewWeight() {
      let newWeight = {
        weight: "",
        date: "",
      };
      this.untitled.weights.unshift(newWeight);
    },
    removeWeight(index) {
      this.untitled.weights.splice(index, 1);
    },
    saveSelectedItem(item) {
      console.log("cacheSelectedItem is working", item);
      if (this.untitled.special_considerations.includes(item)) {
        console.log(
          "this item exists in array",
          this.untitled.special_considerations,
        );
        this.untitled.special_considerations.forEach(
          (alreadySavedItem, index) => {
            if (item == alreadySavedItem) {
              this.untitled.special_considerations.splice(index, 1);
            }
          },
        );
      } else {
        console.log(
          "this item does not exist in array",
          this.untitled.special_considerations,
        );
        this.untitled.special_considerations.push(item);
      }
    },
    getPersonalAddressData(addressData, propertyData, id) {
      this.address.state = addressData.administrative_area_level_1;
      this.address.city = addressData.administrative_area_level_2;
      this.address.street_address = `${
        document.getElementById(id).value.split(" ")[0]
      } ${addressData.route}`;
      this.address.country = addressData.country;
      this.address.postcode = addressData.postal_code;
      this.address.suburb = addressData.locality;
      console.log(
        "this is the address now",
        addressData,
        propertyData,
        this.address,
      );
    },
    clearGP() {
      this.untitled.gp = {};
      this.gp = "";
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    validateDOB() {
      if (this.personalInformation.dob) {
        this.personalInformation.dob = new Date(this.personalInformation.dob);
        this.personalInformation.dob =
          this.personalInformation.dob.toLocaleDateString("en-au");
        if (
          this.personalInformation.dob.split("/").length < 3 ||
          this.personalInformation.dob.split("/")[2].length < 4
        ) {
          console.log("DOB IS INCORRECT", this.personalInformation.dob);
          this.errorDOB = true;
        } else {
          this.errorDOB = false;
          this.editPersonalPatientInfo();
          console.log("DOB IS CORRECT", this.personalInformation.dob);
        }
      } else {
        if (this.isSimplified) {
          this.errorDOB = false;
          this.editPersonalPatientInfo();
        } else {
          this.errorDOB = true;
        }
      }
    },
    submitConsent() {
      this.loading = true;
      this.displaySuccessModal = true;
      this.first_spec_line = "Saving informed consent...";
      axios
        .post(
          `/person/${this.patientUUID}/consent`,
          this.consent,
          this.$store.state.header,
        )
        .then((res) => {
          console.log("consent submitted", res);
          this.loading = false;
          this.first_spec_line = "Successfully saved informed consent!";

          // Update local storage
          if (this.consent.consent_type === "psychotropic") {
            this.psychotropicConsent = res.data;
          } else {
            this.prescribingConsent = res.data;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.errActions =
            err.response && err.response.data
              ? err.response.data
              : "Error saving consent";
          console.log("Error saving consent", err);
        });
    },
    updateConsentForm() {
      let target =
        this.consent.consent_type === "psychotropic"
          ? this.psychotropicConsent
          : this.prescribingConsent;
      if (target) {
        this.consent.has_consented = target.has_consented;
        this.consent.given_by = target.given_by;
        this.consent.given_date = target.given_date;
      } else {
        this.consent.has_consented = false;
        this.consent.given_by = "";
        this.consent.given_date = "";
      }
    },
  },
  watch: {
    "consent.consent_type": function (newVal, oldVal) {
      this.updateConsentForm();
    },
  },
  mounted() {
    this.getFacilities();
    // this.getFacilityPrescibers();
    this.patientUUID = this.$route.params.id;
    this.selectedNavigation = resolvePatientProfileTab(
      this.navigationItems,
      this.$route.query.subtab,
    );
    if (this.$store.state.user?.enmrc_eprescribing_active) {
      this.getPharmacies();
    }
    // let tempDobStorage = '';
    this.loadingPatient = true;
    axios
      .post(
        "/retrieve-patient",
        {
          patient_id: this.patientUUID,
          location: this.$store.state.currentLocation.uuid,
        },
        this.$store.state.header,
      )
      .then((res) => {
        this.patient = res.data;
        this.loadingPatient = false;
        this.selectedStatus = this.patient.status.toLowerCase();
        this.patient.personal_information.age = this.getAge(
          this.patient.personal_information.dob,
        );
        this.patient.personal_information.image = "";
        if (this.patient.considerations && this.patient.considerations.length) {
          console.log(
            "PATIENT HAS SPECIAL CONSIDERATIONS",
            this.patient.considerations,
          );
          if (
            this.patient.considerations[this.patient.considerations.length - 1]
              .special_considerations.length
          ) {
            this.patient.considerations[
              this.patient.considerations.length - 1
            ].special_considerations.forEach((item) => {
              this.untitled.special_considerations.push(
                item.name.slice(0, 1).toUpperCase() + item.name.slice(1),
              );
            });
          }
          this.untitled.special_considerations_notes =
            this.patient.considerations[
              this.patient.considerations.length - 1
            ].comments;
        }
        this.patient.prescribers.forEach((prescriber, index) => {
          if (prescriber.uuid != this.patient.primary_prescriber?.uuid) {
            this.facilitiesPrescribers.push(prescriber);
          }
        });
        // Dynamically add sex option if it's not in the dropdown list
        const loadedSex = this.patient.personal_information.sex;
        if (loadedSex && !this.sex.some((item) => item.sex === loadedSex)) {
          this.sex.push({ sex: loadedSex });
        }

        this.personalInformation = {
          first_name: this.patient.personal_information.first_name
            ? this.patient.personal_information.first_name
            : "",
          last_name: this.patient.personal_information.last_name
            ? this.patient.personal_information.last_name
            : "",
          preferred_name: this.patient.personal_information.preferred_name
            ? this.patient.personal_information.preferred_name
            : "",
          sex: this.patient.personal_information.sex
            ? this.patient.personal_information.sex
            : "",
          dob: this.patient.personal_information.dob
            ? `${this.patient.personal_information.dob.split("/")[2]}-${
                this.patient.personal_information.dob.split("/")[1]
              }-${this.patient.personal_information.dob.split("/")[0]}`
            : "",
          similar_sounding_name: this.patient.personal_information
            .similar_sounding_name
            ? this.patient.personal_information.similar_sounding_name
            : false,
        };

        this.clinicalDetails = {
          height_cm: this.patient.latest_height_reading?.value ?? "",
          weight_kg: this.patient.latest_weight_reading?.value ?? "",
        };

        // this.patient.personal_information.image = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMyn74IpFH6FKnyy1JRAL2UTgIsxdByOVUIA&usqp=CAU';
        console.log(
          "this is the res data for retrieve patient",
          res.data,
          this.patient,
        );

        // IMAGE
        this.previewImage =
          this.patient &&
          this.patient.image_information &&
          this.patient.image_information.url
            ? this.patient.image_information.url
            : "";
        this.personalInformation.dob = `${
          this.patient.personal_information.dob.split("/")[2]
        }-${this.patient.personal_information.dob.split("/")[1]}-${
          this.patient.personal_information.dob.split("/")[0]
        }`;
      })
      .then(() => {
        // get the prescribers of the location
        this.getPrescribers();
        // IHI number
        axios
          .post(`/person/${this.patientUUID}/ihi`, {}, this.$store.state.header)
          .then((res2) => {
            this.ihiDetails = res2.data;
            if (res2.data.conflicted) {
              this.displayIHIConflictModal = true;
            }

            if (this.patient.psychotropic_consent) {
              this.psychotropicConsent = {
                ...this.patient.psychotropic_consent,
              };
              if (
                this.psychotropicConsent.has_consented === null ||
                this.psychotropicConsent.has_consented === undefined
              ) {
                this.psychotropicConsent.has_consented = false;
              }
            }
            if (this.patient.prescribing_consent) {
              this.prescribingConsent = { ...this.patient.prescribing_consent };
              if (
                this.prescribingConsent.has_consented === null ||
                this.prescribingConsent.has_consented === undefined
              ) {
                this.prescribingConsent.has_consented = false;
              }
            }
            // Set default view to psychotropic
            this.updateConsentForm();
          })
          .catch((err) => {
            console.log("this is the error of the ihi call", err.response.data);
          });

        // tempDobStorage = new Date(this.patient.personal_information.dob);
        // console.log('THIS IS THE TEMP STORAGE DOB', tempDobStorage);
        // this.personalInformation.dob = tempDobStorage.toISOString().split('T')[0];
        // console.log('THIS IS THE PERSONAL INFORMATION DOB', this.personalInformation.dob, tempDobStorage.toISOString().split('T')[0]);

        // PRESCRIBERS
        if (this.patient.primary_prescriber) {
          this.selectedPrescriber = this.patient.primary_prescriber;
          this.selectedPrescriber.name = `${this.patient.primary_prescriber.personal_information.first_name} ${this.patient.primary_prescriber.personal_information.last_name}`;
        }

        // PHARMACY
        if (this.patient.pharmacy) {
          this.selectedPharmacy = this.patient.pharmacy;
        }

        // NEXT OF KIN
        if (this.patient.emergency.length) {
          this.kin = this.patient.emergency[0];
          this.kin.first_name = this.patient.emergency[0].first_name;
          this.kin.last_name = this.patient.emergency[0].last_name;
        }

        // NKDA is recorded as a regular Adr entry (reaction_type === "nkda") rather than a
        // separate flag, so it needs to be pulled out of the list before populating the
        // free-text ADR editor below.
        const nkdaMarker = (this.patient.adr || []).find(isNkdaEntry);
        this.nkda = !!nkdaMarker;
        this.nkdaUuid = nkdaMarker ? nkdaMarker.uuid : null;

        if (this.patient.adr && this.patient.adr.length) {
          this.untitled.adr = getRealAdrs(this.patient.adr);
          this.untitled.adr.forEach((item) => {
            if (item.date) {
              item.date = new Date(item.date)
                .toLocaleString("en-au")
                .slice(0, 10);
              console.log("this is item before assigning", item.date);
              let b = item.date.split("/");
              console.log("this is b at split", b);
              b = `${b[2]}-${b[1]}-${b[0]}`;
              console.log("this is b after concating", b);
              item.date = b;
            }
            if (!item.status) {
              item.status = "Active";
            }
            if (!item.drug && item.alias && item.alias.alias_id) {
              item.drug = item.alias.alias_id;
            }
            if (!item.drug_name) {
              item.drug_name = (item.alias && item.alias.name) || "";
            }
          });
          this.adrPristineSnapshot = {};
          this.untitled.adr.forEach((item) => {
            if (item.uuid) {
              this.adrPristineSnapshot[item.uuid] = this.serializeAdrForCompare(item);
            }
          });
        }

        // CONTACT METHODS
        this.patient.contact_methods.forEach((method) => {
          if (method.type == "phone") {
            this.untitled.phone = method.data;
            this.untitled.phone_uuid = method.uuid;
            this.initialContact.phone = method.data;
          }
          if (method.type == "email") {
            this.untitled.email = method.data;
            this.untitled.email_uuid = method.uuid;
            this.initialContact.email = method.data;
          }
        });

        // ENTITLEMENT/REGULATORY NUMBERS
        // , 'Medicare Expiry'
        let reg_types = [
          "RAC ID",
          "URN/MRN Number",
          "Pharmaceutical Entitlement Number",
          "Medicare Number",
          "Safety Net Number",
          "Safety Net Number 2",
          "DVA Number",
          "Concession Number",
          "CAAC ID",
        ];
        let included_reg = [];
        this.patient.regulatory_information.forEach((ent_number) => {
          if (
            ent_number.regulatory_type === "DVA Number" &&
            ent_number.data &&
            ent_number.data.includes("|")
          ) {
            let parts = ent_number.data.split("|");
            ent_number.data = parts[0];
            let status = parts[1];
            if (status === "DVAGold") status = "DVA Gold";
            if (status === "DVAWhite") status = "DVA White";
            if (status === "DVAOrange") status = "DVA Orange";
            ent_number.regulatory_type = status;
          }

          let checkType = ["DVA Gold", "DVA White", "DVA Orange"].includes(
            ent_number.regulatory_type,
          )
            ? "DVA Number"
            : ent_number.regulatory_type;

          if (reg_types.includes(checkType)) {
            // Ensure expiry exists to prevent Calendar rendering crashes
            if (
              ent_number.expiry === undefined ||
              ent_number.expiry === null ||
              ent_number.expiry === ""
            ) {
              ent_number.expiry = "";
            } else {
              ent_number.expiry = new Date(ent_number.expiry);
            }
            this.regulatory_numbers.push(ent_number);
            included_reg.push(checkType);
            console.log("this is what is included so far", included_reg);
            if (ent_number.regulatory_type == "Medicare Number") {
              this.currMedicare = ent_number.data;
            }
            if (
              ["DVA Number", "DVA Gold", "DVA White", "DVA Orange"].includes(
                ent_number.regulatory_type,
              )
            ) {
              this.currDVA = ent_number.data;
            }
          }
        });
        let not_included = reg_types.filter((x) => !included_reg.includes(x));
        console.log("this is what was not included yet", not_included);
        not_included.forEach((excl) => {
          this.regulatory_numbers.push({
            regulatory_type: excl,
            expiry: "",
            data: "",
          });
        });

        // Format initial backend data
        setTimeout(() => {
          if (
            this.medicareIndex !== -1 &&
            this.regulatory_numbers[this.medicareIndex].data
          ) {
            this.formatMedicareInput("edit");
          }
        }, 50);
      })
      .catch((err) => {
        console.log("this is the err", err);
        if (
          err.response &&
          err.response.data &&
          err.response.data.split(" ").includes("expired")
        ) {
          console.log("yes, it does include expired");
          this.$router.push("/login");
        }
      });
  },
  computed: {
    isSimplified() {
      return isSimplifiedOnboarding(this.$store, this.patient);
    },
    medicareIndex() {
      return this.regulatory_numbers.findIndex(
        (item) => item.regulatory_type === "Medicare Number",
      );
    },
    dvaIndex() {
      return this.regulatory_numbers.findIndex((item) =>
        ["DVA Number", "DVA Gold", "DVA White", "DVA Orange"].includes(
          item.regulatory_type,
        ),
      );
    },
    validMedicareNumber() {
      if (this.medicareIndex !== -1) {
        return this.validateMedicareNumber(
          this.regulatory_numbers[this.medicareIndex].data,
        );
      }
      return false;
    },
    validMedicareExpiry() {
      if (this.medicareIndex !== -1) {
        return validateExpiryInFuture(
          this.regulatory_numbers[this.medicareIndex].expiry,
        );
      }
      return true;
    },
    validDVANumber() {
      if (this.dvaIndex !== -1) {
        return this.validateDVANumber(
          this.regulatory_numbers[this.dvaIndex].data,
        );
      }
      return true;
    },
    validDVAExpiry() {
      if (this.dvaIndex !== -1) {
        return validateExpiryInFuture(
          this.regulatory_numbers[this.dvaIndex].expiry,
        );
      }
      return true;
    },
    grouped_regulatory_numbers() {
      return this.regulatory_numbers.filter(
        (item) =>
          item.regulatory_type != "Medicare Number" &&
          !["DVA Number", "DVA Gold", "DVA White", "DVA Orange"].includes(
            item.regulatory_type,
          ),
      );
    },
    personal_regulatory_numbers() {
      return this.regulatory_numbers.filter(
        (item) =>
          item.regulatory_type == "Medicare Number" ||
          ["DVA Number", "DVA Gold", "DVA White", "DVA Orange"].includes(
            item.regulatory_type,
          ),
      );
    },
    medicare_num() {
      return this.regulatory_numbers.filter(
        (item) => item.regulatory_type == "Medicare Number",
      );
    },
    dva_num() {
      return this.regulatory_numbers.filter((item) =>
        ["DVA Number", "DVA Gold", "DVA White", "DVA Orange"].includes(
          item.regulatory_type,
        ),
      );
    },
  },
};
</script>

<style lang="scss">
@import "../assets/css/main.scss";

.edit-icon {
  display: none !important;
}

.edit-icon-text {
  display: none;
}

.form-fields {
  display: flex;
  flex-wrap: wrap;
}

.form-field {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  margin-right: 20px;
  margin-top: 15px;

  label {
    color: #64748b;
    font-weight: 500;
    font-size: 0.9em;
    margin-bottom: 6px;
    padding-left: 4px;
    display: block;
  }

  input[type="text"],
  input[type="number"],
  input[type="date"],
  input[type="password"],
  select,
  textarea {
    display: block;
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background-color: #f8fafc;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #0870dc;
      box-shadow: 0 0 0 3px rgba(8, 112, 220, 0.15);
      background-color: #ffffff;
    }

    &:disabled {
      background-color: #f1f5f9;
      color: #94a3b8;
      cursor: not-allowed;
    }
  }
}

.text-field {
  width: 20em;
}

.date-field {
  width: 20em;
}

.address-field {
  width: 12em;
}

.special-considerations-form {
  background-color: $grey;
  padding: 10px;
  border-radius: 8px;
}

.spec-cons-items {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.spec-cons-item {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.vac-weight-table {
  max-height: 300px;
  overflow-y: scroll;
}

// .form-control{
//     width: 20em;
// }

.prescriber-info-form-content {
  h3 {
    margin-top: 12px;
  }
}

#monthpicker {
  background-color: #f3f4f4 !important;
}

.patient-edit-container {
  display: flex;
  flex-direction: column;
}

.horizontal-tabs-container {
  background-color: #f8fafc;
  border-radius: 12px;
  padding: 8px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f5f9;
}

.horizontal-tabs {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px;

  /* Hide scrollbar for cleaner look but keep functionality */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.horizontal-tab-item {
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  p {
    margin: 0;
    color: #64748b;
    font-weight: 600;
    font-size: 0.95em;
    transition: color 0.2s;
  }

  &:hover {
    background-color: #f1f5f9;
    p {
      color: #334155;
    }
  }

  &.active-tab {
    background-color: #0870dc;
    box-shadow: 0 2px 6px rgba(8, 112, 220, 0.25);
    p {
      color: white !important;
    }
  }

  &.completed-tab {
    border: 2px solid #00ad50;
  }
}

/* --- Premium UI Enhancements --- */

.patient-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #f1f5f9;
  padding: 24px;
  margin-bottom: 24px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.03);
  }
}

.button {
  border-radius: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    filter: brightness(1.05);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
}
</style>
